/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
export type ExchangePostRequest = {
  token: string;
};

export type FileDetailsResponse = {
  id: string;
  name: string;
  mimetype: string;
  size: number;
  createdAt: string;
};

export type UploadFileRequest = {
  file: Blob | File;
};

export type CompanyDetailsResponse = {
  name: string;
  country: string;
  state: string;
  city: string;
  postcode: string;
  email: string;
  address: string;
  address2: string;
  address3: string;
  website: string;
  uploads: string[];
};

export type CompanyActions = {
  canAddRaToCompany: boolean;
};

export type CompanyResponseStatus = typeof CompanyResponseStatus[keyof typeof CompanyResponseStatus];


export const CompanyResponseStatus = {
  active: 'active',
  blocked: 'blocked',
  closed: 'closed',
  removed: 'removed',
  awaitingReview: 'awaitingReview',
} as const;

export type CompanyResponse = {
  id: string;
  name: string;
  details: CompanyDetailsResponse;
  status: CompanyResponseStatus;
  actions: CompanyActions;
  isRaCompany: boolean;
  namePrivacyEnabled: boolean;
};

export type CompanyMembershipStatus = typeof CompanyMembershipStatus[keyof typeof CompanyMembershipStatus];


export const CompanyMembershipStatus = {
  active: 'active',
  blocked: 'blocked',
} as const;

export type CompanyListItemCr = {
  crName: string;
  crLastName: string;
  crEmail: string;
  crStatus: CompanyMembershipStatus;
};

export type CompanyStatus = typeof CompanyStatus[keyof typeof CompanyStatus];


export const CompanyStatus = {
  active: 'active',
  blocked: 'blocked',
  closed: 'closed',
  removed: 'removed',
  awaitingReview: 'awaitingReview',
} as const;

export type CompanyListResponseItem = {
  companyId: string;
  companyName: string;
  isRaCompany: boolean;
  /** @nullable */
  cr: CompanyListItemCr | null;
  status: CompanyStatus;
};

export type UpdatedCompanyDetailsPayload = {
  name?: string;
  /** ISO2 country code */
  country?: string;
  city?: string;
  postcode?: string;
  address?: string;
  website?: string;
  state?: string;
  address2?: string;
  address3?: string;
};

export type UpdateCompanyRequest = {
  details: UpdatedCompanyDetailsPayload;
};

export type UpdateCompanyNamePrivacyRequest = {
  namePrivacyEnabled: boolean;
};

export type UpdateCompanyDocumentsRequest = {
  uploads: (Blob | File)[];
};

export type AddCompanyRepRequest = {
  emails: string[];
};

export type AddCompanyRepResponse = {
  processedEmails: string[];
  errors: string[];
};

export type RevokeCRInvitationRequest = {
  email: string;
};

export type SimpleAccountResponseType = typeof SimpleAccountResponseType[keyof typeof SimpleAccountResponseType];


export const SimpleAccountResponseType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type SimpleAccountResponse = {
  id: string;
  name: string;
  type: SimpleAccountResponseType;
  companyName: string;
  trusted: boolean;
};

export type SimpleAccountDataResponse = { [key: string]: unknown };

export type AirTransportAccountDataResponse = {
  icaoAirlineDesignator?: string;
};

export type FuelProviderAccountDataResponseSustainabilityCertificationSchemeItem = typeof FuelProviderAccountDataResponseSustainabilityCertificationSchemeItem[keyof typeof FuelProviderAccountDataResponseSustainabilityCertificationSchemeItem];


export const FuelProviderAccountDataResponseSustainabilityCertificationSchemeItem = {
  classNkCorsia: 'classNkCorsia',
  rsbCorsia: 'rsbCorsia',
  isccCorsia: 'isccCorsia',
  rsbEuRed: 'rsbEuRed',
  isccEu: 'isccEu',
  rsbGlobal: 'rsbGlobal',
  isccPlus: 'isccPlus',
} as const;

export type FuelProviderAccountDataResponse = {
  documents: string[];
  sustainabilityCertificationScheme: FuelProviderAccountDataResponseSustainabilityCertificationSchemeItem[];
};

export type AccountBlockReason = typeof AccountBlockReason[keyof typeof AccountBlockReason];


export const AccountBlockReason = {
  NotEnoughApprovers: 'NotEnoughApprovers',
  CompanyBlocked: 'CompanyBlocked',
} as const;

export type AccountInfoResponseType = typeof AccountInfoResponseType[keyof typeof AccountInfoResponseType];


export const AccountInfoResponseType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type AccountInfoResponseAccountStatus = typeof AccountInfoResponseAccountStatus[keyof typeof AccountInfoResponseAccountStatus];


export const AccountInfoResponseAccountStatus = {
  awaitingReview: 'awaitingReview',
  active: 'active',
  blocked: 'blocked',
  closed: 'closed',
  rejected: 'rejected',
  removed: 'removed',
} as const;

export type AccountInfoResponse = {
  id: string;
  name: string;
  type: AccountInfoResponseType;
  companyId: string;
  companyName: string;
  accountStatus: AccountInfoResponseAccountStatus;
  accountData: SimpleAccountDataResponse | AirTransportAccountDataResponse | FuelProviderAccountDataResponse;
  requiredSignatures: number;
  approversCount: number;
  documents: string[];
  blockReasons: AccountBlockReason[];
};

export type ToggleTrustedAccountRequest = {
  trustedAccountId: string;
  trusted: boolean;
};

export type FuelProviderAccountDataRequestType = typeof FuelProviderAccountDataRequestType[keyof typeof FuelProviderAccountDataRequestType];


export const FuelProviderAccountDataRequestType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type FuelProviderAccountDataRequestSustainabilityCertificationSchemeItem = typeof FuelProviderAccountDataRequestSustainabilityCertificationSchemeItem[keyof typeof FuelProviderAccountDataRequestSustainabilityCertificationSchemeItem];


export const FuelProviderAccountDataRequestSustainabilityCertificationSchemeItem = {
  classNkCorsia: 'classNkCorsia',
  rsbCorsia: 'rsbCorsia',
  isccCorsia: 'isccCorsia',
  rsbEuRed: 'rsbEuRed',
  isccEu: 'isccEu',
  rsbGlobal: 'rsbGlobal',
  isccPlus: 'isccPlus',
} as const;

export type FuelProviderAccountDataRequest = {
  type: FuelProviderAccountDataRequestType;
  sustainabilityCertificationScheme: FuelProviderAccountDataRequestSustainabilityCertificationSchemeItem[];
};

export type GeneralAccountDataType = typeof GeneralAccountDataType[keyof typeof GeneralAccountDataType];


export const GeneralAccountDataType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type GeneralAccountData = {
  type: GeneralAccountDataType;
};

export type AirTransportAccountDataType = typeof AirTransportAccountDataType[keyof typeof AirTransportAccountDataType];


export const AirTransportAccountDataType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type AirTransportAccountData = {
  type: AirTransportAccountDataType;
  icaoAirlineDesignator?: string;
};

export type LogisticsProviderAccountDataType = typeof LogisticsProviderAccountDataType[keyof typeof LogisticsProviderAccountDataType];


export const LogisticsProviderAccountDataType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type LogisticsProviderAccountData = {
  type: LogisticsProviderAccountDataType;
};

export type NewAccountRepRoles = typeof NewAccountRepRoles[keyof typeof NewAccountRepRoles];


export const NewAccountRepRoles = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type NewAccountRepresentativeItem = {
  email: string;
  role: NewAccountRepRoles;
};

export type CreateAccountRequest = {
  accountName: string;
  accountRepresentativesToJoin: NewAccountRepresentativeItem[];
  requiredSignatures: number;
  accountData: FuelProviderAccountDataRequest | GeneralAccountData | AirTransportAccountData | LogisticsProviderAccountData;
  accountDocuments: (Blob | File)[];
  joinCompanyRepresentativeAsAccountRepresentative: boolean;
};

export type AccountCreationResponse = {
  accountId: string;
};

export type AccountType = typeof AccountType[keyof typeof AccountType];


export const AccountType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type AccountApiStatus = typeof AccountApiStatus[keyof typeof AccountApiStatus];


export const AccountApiStatus = {
  awaitingReview: 'awaitingReview',
  active: 'active',
  blocked: 'blocked',
  closed: 'closed',
  rejected: 'rejected',
  removed: 'removed',
} as const;

export type AccountUser = {
  id: string;
  name: string;
  email: string;
};

export type AccountResponse = {
  id: string;
  type: AccountType;
  name: string;
  companyId: string;
  holdingsVolume: number;
  status: AccountApiStatus;
  blockReasons: AccountBlockReason[];
  representative: AccountUser;
};

export type AccountState = typeof AccountState[keyof typeof AccountState];


export const AccountState = {
  awaitingReview: 'awaitingReview',
  active: 'active',
  blocked: 'blocked',
  closed: 'closed',
  removed: 'removed',
} as const;

export type AccountMembershipRole = typeof AccountMembershipRole[keyof typeof AccountMembershipRole];


export const AccountMembershipRole = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type AccountWithRoleResponse = {
  id: string;
  type: AccountType;
  name: string;
  companyId: string;
  status: AccountState;
  role: AccountMembershipRole;
};

export type AddAccountRepRequest = {
  accountRepresentativesToJoin: NewAccountRepresentativeItem[];
};

export type RevokeARInvitationRequest = {
  email: string;
};

export type ChangeRoleRequestRole = typeof ChangeRoleRequestRole[keyof typeof ChangeRoleRequestRole];


export const ChangeRoleRequestRole = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type ChangeRoleRequest = {
  role: ChangeRoleRequestRole;
};

export type BlockAccountRequest = {
  reason?: string;
};

export type UpdateAccountRequest = {
  name?: string;
  requiredSignatures?: number;
  accountData?: FuelProviderAccountDataRequest | GeneralAccountData | AirTransportAccountData | LogisticsProviderAccountData;
  newDocuments?: (Blob | File)[];
};

export type OnboardCompanyRequest = {
  email: string;
};

export type GetOnboardingResponseStatus = typeof GetOnboardingResponseStatus[keyof typeof GetOnboardingResponseStatus];


export const GetOnboardingResponseStatus = {
  pendingUserData: 'pendingUserData',
  pendingVerification: 'pendingVerification',
  pendingInternalAction: 'pendingInternalAction',
  onboarded: 'onboarded',
  failed: 'failed',
} as const;

export type GetOnboardingResponse = {
  status: GetOnboardingResponseStatus;
};

export type UserDetailsDTO = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  employerName: string;
  middleName?: string;
};

export type SetUserDetailsRequest = {
  user: UserDetailsDTO;
};

export type CompanyDetailsDTO = {
  name: string;
  email: string;
  /** ISO2 country code */
  country: string;
  city: string;
  postcode: string;
  address: string;
  website: string;
  state?: string;
  address2?: string;
  address3?: string;
};

export type SetUserCompanyDetailsRequest = {
  company: CompanyDetailsDTO;
  user: UserDetailsDTO;
  companyUploads: (Blob | File)[];
};

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


export const UserStatus = {
  active: 'active',
  blocked: 'blocked',
} as const;

export type CompanyRole = typeof CompanyRole[keyof typeof CompanyRole];


export const CompanyRole = {
  companyRepresentative: 'companyRepresentative',
  regular: 'regular',
} as const;

export type UserDataCompanyItemMembershipStatus = typeof UserDataCompanyItemMembershipStatus[keyof typeof UserDataCompanyItemMembershipStatus];


export const UserDataCompanyItemMembershipStatus = {
  active: 'active',
  removed: 'removed',
} as const;

export type UserDataCompanyItem = {
  id: string;
  name: string;
  role: CompanyRole;
  membershipStatus: UserDataCompanyItemMembershipStatus;
};

export type AccountMembershipResponseStatus = typeof AccountMembershipResponseStatus[keyof typeof AccountMembershipResponseStatus];


export const AccountMembershipResponseStatus = {
  active: 'active',
  removed: 'removed',
} as const;

export type AccountMembershipResponse = {
  id: number;
  accountId: string;
  role: AccountMembershipRole;
  status: AccountMembershipResponseStatus;
  userId: string;
};

export type UserDataWithOnboardingStatus = {
  id: string;
  name: string;
  email: string;
  status: UserStatus;
  companies: UserDataCompanyItem[];
  accounts: AccountResponse[];
  accountMemberships: AccountMembershipResponse[];
  isRegistryAdmin: boolean;
  isPendingOnboardingApproval: boolean;
};

export type AccountMembershipStatus = typeof AccountMembershipStatus[keyof typeof AccountMembershipStatus];


export const AccountMembershipStatus = {
  active: 'active',
  removed: 'removed',
} as const;

export type UserDataAccountItem = {
  id: string;
  name: string;
  role: AccountMembershipRole;
  membershipStatus: AccountMembershipStatus;
};

export type UserDataCompanyInvitationItemRole = typeof UserDataCompanyInvitationItemRole[keyof typeof UserDataCompanyInvitationItemRole];


export const UserDataCompanyInvitationItemRole = {
  companyRepresentative: 'companyRepresentative',
  regular: 'regular',
} as const;

export type UserDataCompanyInvitationItem = {
  id: string;
  name: string;
  role: UserDataCompanyInvitationItemRole;
};

export type UserDataAccountInvitationItemRole = typeof UserDataAccountInvitationItemRole[keyof typeof UserDataAccountInvitationItemRole];


export const UserDataAccountInvitationItemRole = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type UserDataAccountInvitationItem = {
  id: string;
  name: string;
  role: UserDataAccountInvitationItemRole;
};

export type UserListResponseItem = {
  userId: string;
  name: string;
  email: string;
  status: UserStatus;
  companies: UserDataCompanyItem[];
  accounts: UserDataAccountItem[];
  companyInvitations: UserDataCompanyInvitationItem[];
  accountInvitations: UserDataAccountInvitationItem[];
};

export type UpdateUserDetailsItem = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  employerName?: string;
  phoneNumber?: string;
};

export type UpdateUserRequest = {
  email?: string;
  details?: UpdateUserDetailsItem;
};

export type CompanyUserDataItem = {
  id: string;
  name: string;
  email: string;
  status: UserStatus;
  companies: UserDataCompanyItem[];
  accounts: AccountResponse[];
  accountMemberships: AccountMembershipResponse[];
  isRegistryAdmin: boolean;
  isPromotingToCr: boolean;
};

export type GetAccountUsersResponseRole = typeof GetAccountUsersResponseRole[keyof typeof GetAccountUsersResponseRole];


export const GetAccountUsersResponseRole = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type GetAccountUsersResponseStatus = typeof GetAccountUsersResponseStatus[keyof typeof GetAccountUsersResponseStatus];


export const GetAccountUsersResponseStatus = {
  active: 'active',
  blocked: 'blocked',
} as const;

export type GetAccountUsersResponse = {
  id: string;
  name: string;
  email: string;
  role: GetAccountUsersResponseRole;
  status: GetAccountUsersResponseStatus;
};

export type GetCompanyInvitedResponse = {
  email: string;
  hasPendingApproval: boolean;
};

export type InvitedAccountMembershipDtoRole = typeof InvitedAccountMembershipDtoRole[keyof typeof InvitedAccountMembershipDtoRole];


export const InvitedAccountMembershipDtoRole = {
  accountRepFullAccess: 'accountRepFullAccess',
  accountRepApprover: 'accountRepApprover',
  accountRepInitiator: 'accountRepInitiator',
  readOnly: 'readOnly',
} as const;

export type InvitedAccountMembershipDto = {
  role: InvitedAccountMembershipDtoRole;
  accountId: string;
};

export type GetAccountInvitedResponse = {
  email: string;
  accounts: InvitedAccountMembershipDto[];
};

export type UserDataResponse = {
  id: string;
  name: string;
  email: string;
  status: UserStatus;
  companies: UserDataCompanyItem[];
  accounts: AccountResponse[];
  accountMemberships: AccountMembershipResponse[];
  isRegistryAdmin: boolean;
};

export type UserDetailsResponse = {
  id: string;
  email: string;
  name: string;
  details: UserDetailsDTO;
};

export type GetPendingActionsCountResponse = {
  pendingSignatureCount: number;
  pendingAcceptanceCount: number;
  pendingApprovalCount: number;
};

export type UnitProcessActorDTOAccountType = typeof UnitProcessActorDTOAccountType[keyof typeof UnitProcessActorDTOAccountType];


export const UnitProcessActorDTOAccountType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type UnitProcessActorDTO = {
  userId: string;
  userName: string;
  userEmail: string;
  accountId: string;
  accountName: string;
  accountType: UnitProcessActorDTOAccountType;
};

export type IssueProcessState = typeof IssueProcessState[keyof typeof IssueProcessState];


export const IssueProcessState = {
  issuanceStarted: 'issuanceStarted',
  pendingSignaturesNotification: 'pendingSignaturesNotification',
  pendingSignatures: 'pendingSignatures',
  signaturesRejected: 'signaturesRejected',
  signaturesExpired: 'signaturesExpired',
  pendingApprovalCreation: 'pendingApprovalCreation',
  pendingApproval: 'pendingApproval',
  approvalRejected: 'approvalRejected',
  pendingIssuance: 'pendingIssuance',
  pendingParticipantsNotification: 'pendingParticipantsNotification',
  issued: 'issued',
  cancelled: 'cancelled',
  removed: 'removed',
} as const;

export type SignaturesResponse = {
  accountId: string;
  userId: string;
};

export type MaybeCensoredOwnerId = {
  __censored: boolean;
  value: string;
};

export type MaybeCensoredIsLast = {
  __censored: boolean;
  value: boolean;
};

export type MaybeCensoredComputedValue = { [key: string]: unknown };

export type MaybeCensoredComputed = {
  __censored: boolean;
  value: MaybeCensoredComputedValue;
};

export type MaybeCensoredMetadataValue = { [key: string]: unknown };

export type MaybeCensoredMetadata = {
  __censored: boolean;
  value: MaybeCensoredMetadataValue;
};

export type UnitType = typeof UnitType[keyof typeof UnitType];


export const UnitType = {
  Issue: 'Issue',
  Claim: 'Claim',
  Split: 'Split',
  Transfer: 'Transfer',
} as const;

export type MaybeCensoredType = {
  __censored: boolean;
  value: UnitType;
};

export type UnitStatus = typeof UnitStatus[keyof typeof UnitStatus];


export const UnitStatus = {
  active: 'active',
  blocked: 'blocked',
  retired: 'retired',
  removed: 'removed',
  expired: 'expired',
} as const;

export type MaybeCensoredStatus = {
  __censored: boolean;
  value: UnitStatus;
};

export type UnitDTO = {
  /** ID field is always present, however if the unit was not created yet, the ID will be empty string */
  id: string;
  /** Root ID field is always present, however if the unit was not created yet, the Root ID will be empty string */
  rootId: string;
  volume: number;
  ownerId: MaybeCensoredOwnerId;
  isLast: MaybeCensoredIsLast;
  computed: MaybeCensoredComputed;
  metadata: MaybeCensoredMetadata;
  type: MaybeCensoredType;
  status: MaybeCensoredStatus;
  note: string;
};

export type IssueProcessDTOComputed = { [key: string]: unknown };

export type IssueProcessDTOMetadata = { [key: string]: unknown };

export type IssueProcessDTO = {
  id: string;
  actor: UnitProcessActorDTO;
  createdAt: string;
  type: string;
  sendingAccountId: string;
  sendingAccountName: string;
  sendingCompanyId: string;
  sendingCompanyName: string;
  receivingAccountId: string;
  receivingAccountName: string;
  receivingCompanyId: string;
  receivingCompanyName: string;
  computed: IssueProcessDTOComputed;
  state: IssueProcessState;
  approvalRequestId: string;
  signatures: SignaturesResponse[];
  minimalSignaturesNumber: number;
  issuedBlockId: string;
  metadata: IssueProcessDTOMetadata;
  volume: number;
  unit: UnitDTO;
  /** @nullable */
  processExpirationDate: string | null;
};

export type TransferProcessState = typeof TransferProcessState[keyof typeof TransferProcessState];


export const TransferProcessState = {
  transferStarted: 'transferStarted',
  pendingSignaturesNotification: 'pendingSignaturesNotification',
  pendingSignatures: 'pendingSignatures',
  signaturesRejected: 'signaturesRejected',
  signaturesExpired: 'signaturesExpired',
  pendingAcceptance: 'pendingAcceptance',
  acceptanceRejected: 'acceptanceRejected',
  acceptanceExpired: 'acceptanceExpired',
  pendingTransfer: 'pendingTransfer',
  transferred: 'transferred',
  cancelled: 'cancelled',
  removed: 'removed',
} as const;

export type TransferProcessDTOComputed = { [key: string]: unknown };

export type TransferProcessDTOMetadata = { [key: string]: unknown };

export type TransferProcessDTO = {
  id: string;
  actor: UnitProcessActorDTO;
  createdAt: string;
  type: string;
  sendingAccountId: string;
  sendingAccountName: string;
  sendingCompanyId: string;
  sendingCompanyName: string;
  receivingAccountId: string;
  receivingAccountName: string;
  receivingCompanyId: string;
  receivingCompanyName: string;
  computed: TransferProcessDTOComputed;
  state: TransferProcessState;
  blockId: string;
  signatures: SignaturesResponse[];
  minimalSignaturesNumber: number;
  metadata: TransferProcessDTOMetadata;
  volume: number;
  unit: UnitDTO;
  /** @nullable */
  processExpirationDate: string | null;
};

export type ClaimProcessState = typeof ClaimProcessState[keyof typeof ClaimProcessState];


export const ClaimProcessState = {
  pendingAccountType: 'pendingAccountType',
  pendingVolume: 'pendingVolume',
  pendingRetirementYear: 'pendingRetirementYear',
  pendingRetirementCountry: 'pendingRetirementCountry',
  pendingSafcBeneficiary: 'pendingSafcBeneficiary',
  pendingClaimPurpose: 'pendingClaimPurpose',
  pendingComplianceRegime: 'pendingComplianceRegime',
  pendingSercBeneficiary: 'pendingSercBeneficiary',
  pendingDecisionProcess: 'pendingDecisionProcess',
  pendingSignaturesNotification: 'pendingSignaturesNotification',
  pendingSignatures: 'pendingSignatures',
  signaturesRejected: 'signaturesRejected',
  signaturesExpired: 'signaturesExpired',
  pendingAcceptanceSAFcA: 'pendingAcceptanceSAFcA',
  acceptanceRejectedSAFcA: 'acceptanceRejectedSAFcA',
  acceptanceExpiredSAFcA: 'acceptanceExpiredSAFcA',
  pendingAcceptanceSAFcE: 'pendingAcceptanceSAFcE',
  acceptanceRejectedSAFcE: 'acceptanceRejectedSAFcE',
  acceptanceExpiredSAFcE: 'acceptanceExpiredSAFcE',
  operationDecision: 'operationDecision',
  pendingSercIssuance: 'pendingSercIssuance',
  pendingClaim: 'pendingClaim',
  notificationFlowDecision: 'notificationFlowDecision',
  pendingExternalBeneficiaryNotification: 'pendingExternalBeneficiaryNotification',
  claimed: 'claimed',
  cancelled: 'cancelled',
  removed: 'removed',
} as const;

export type ClaimProcessDTOComputed = { [key: string]: unknown };

export type ClaimProcessDTOMetadata = { [key: string]: unknown };

export type ClaimProcessDTO = {
  id: string;
  actor: UnitProcessActorDTO;
  createdAt: string;
  type: string;
  sendingAccountId: string;
  sendingAccountName: string;
  sendingCompanyId: string;
  sendingCompanyName: string;
  receivingAccountId: string;
  receivingAccountName: string;
  receivingCompanyId: string;
  receivingCompanyName: string;
  computed: ClaimProcessDTOComputed;
  state: ClaimProcessState;
  blockId: string;
  signatures: SignaturesResponse[];
  minimalSignaturesNumber: number;
  metadata: ClaimProcessDTOMetadata;
  volume: number;
  unit: UnitDTO;
  /** @nullable */
  processExpirationDate: string | null;
  /** @nullable */
  safcClaimBeneficiaryName: string | null;
  /** @nullable */
  sercClaimBeneficiaryName: string | null;
  safcRemainingUnitId?: string;
  safcClaimedUnitId?: string;
  sercRemainingUnitId?: string;
  sercClaimedUnitId?: string;
  sercIssuedUnitId?: string;
};

export type IssueNewTreeProcessState = typeof IssueNewTreeProcessState[keyof typeof IssueNewTreeProcessState];


export const IssueNewTreeProcessState = {
  start: 'start',
  pendingSignaturesNotification: 'pendingSignaturesNotification',
  pendingSignatures: 'pendingSignatures',
  signaturesRejected: 'signaturesRejected',
  signaturesExpired: 'signaturesExpired',
  pendingIssuance: 'pendingIssuance',
  issued: 'issued',
  pendingParticipantsNotification: 'pendingParticipantsNotification',
  cancelled: 'cancelled',
  removed: 'removed',
} as const;

export type IssueNewTreeProcessDTOComputed = { [key: string]: unknown };

export type IssueNewTreeProcessDTOMetadata = { [key: string]: unknown };

export type IssueNewTreeProcessDTO = {
  id: string;
  actor: UnitProcessActorDTO;
  createdAt: string;
  type: string;
  sendingAccountId: string;
  sendingAccountName: string;
  sendingCompanyId: string;
  sendingCompanyName: string;
  receivingAccountId: string;
  receivingAccountName: string;
  receivingCompanyId: string;
  receivingCompanyName: string;
  computed: IssueNewTreeProcessDTOComputed;
  state: IssueNewTreeProcessState;
  genesisBlockId: string;
  signatures: SignaturesResponse[];
  minimalSignaturesNumber: number;
  metadata: IssueNewTreeProcessDTOMetadata;
  volume: number;
  unit: UnitDTO;
  /** @nullable */
  processExpirationDate: string | null;
};

export type SplitProcessState = typeof SplitProcessState[keyof typeof SplitProcessState];


export const SplitProcessState = {
  pendingSplit: 'pendingSplit',
  splitted: 'splitted',
  removed: 'removed',
} as const;

export type SplitProcessDTOComputed = { [key: string]: unknown };

export type SplitProcessDTO = {
  id: string;
  actor: UnitProcessActorDTO;
  createdAt: string;
  type: string;
  sendingAccountId: string;
  sendingAccountName: string;
  sendingCompanyId: string;
  sendingCompanyName: string;
  receivingAccountId: string;
  receivingAccountName: string;
  receivingCompanyId: string;
  receivingCompanyName: string;
  computed: SplitProcessDTOComputed;
  state: SplitProcessState;
  blockId: string;
  volume: number;
  unit: UnitDTO;
  metadata: null;
  /** @nullable */
  processExpirationDate: string | null;
};

export type QueryUnitProcessResponse = {
  count: number;
  processes: (IssueProcessDTO | TransferProcessDTO | ClaimProcessDTO | IssueNewTreeProcessDTO | SplitProcessDTO)[];
};

export type JoinCrApprovalRequestState = typeof JoinCrApprovalRequestState[keyof typeof JoinCrApprovalRequestState];


export const JoinCrApprovalRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type JoinCrApprovalRequestStateChangedReason = { [key: string]: unknown };

export type JoinCrApprovalRequestType = typeof JoinCrApprovalRequestType[keyof typeof JoinCrApprovalRequestType];


export const JoinCrApprovalRequestType = {
  JoinCrApprovalRequest: 'JoinCrApprovalRequest',
} as const;

export type JoinCrApprovalRequest = {
  id: string;
  state: JoinCrApprovalRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: JoinCrApprovalRequestStateChangedReason;
  type: JoinCrApprovalRequestType;
};

export type CrDataApprovalRequestState = typeof CrDataApprovalRequestState[keyof typeof CrDataApprovalRequestState];


export const CrDataApprovalRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CrDataApprovalRequestStateChangedReason = { [key: string]: unknown };

export type CrDataApprovalRequestType = typeof CrDataApprovalRequestType[keyof typeof CrDataApprovalRequestType];


export const CrDataApprovalRequestType = {
  CrDataApprovalRequest: 'CrDataApprovalRequest',
} as const;

export type CrDataApprovalRequest = {
  id: string;
  state: CrDataApprovalRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CrDataApprovalRequestStateChangedReason;
  type: CrDataApprovalRequestType;
};

export type CompanyCreateRequestState = typeof CompanyCreateRequestState[keyof typeof CompanyCreateRequestState];


export const CompanyCreateRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyCreateRequestStateChangedReason = { [key: string]: unknown };

export type CompanyCreateRequestType = typeof CompanyCreateRequestType[keyof typeof CompanyCreateRequestType];


export const CompanyCreateRequestType = {
  CompanyCreateRequest: 'CompanyCreateRequest',
} as const;

export type CompanyCreateRequest = {
  id: string;
  state: CompanyCreateRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyCreateRequestStateChangedReason;
  type: CompanyCreateRequestType;
};

export type AccountDetailsChangeRequestState = typeof AccountDetailsChangeRequestState[keyof typeof AccountDetailsChangeRequestState];


export const AccountDetailsChangeRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type AccountDetailsChangeRequestStateChangedReason = { [key: string]: unknown };

export type AccountDetailsChangeRequestType = typeof AccountDetailsChangeRequestType[keyof typeof AccountDetailsChangeRequestType];


export const AccountDetailsChangeRequestType = {
  AccountDetailsChangeRequest: 'AccountDetailsChangeRequest',
} as const;

export type AccountDetailsChangeRequest = {
  id: string;
  state: AccountDetailsChangeRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: AccountDetailsChangeRequestStateChangedReason;
  type: AccountDetailsChangeRequestType;
};

export type CompanyOnboardRequestState = typeof CompanyOnboardRequestState[keyof typeof CompanyOnboardRequestState];


export const CompanyOnboardRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyOnboardRequestStateChangedReason = { [key: string]: unknown };

export type CompanyOnboardRequestType = typeof CompanyOnboardRequestType[keyof typeof CompanyOnboardRequestType];


export const CompanyOnboardRequestType = {
  CompanyOnboardRequest: 'CompanyOnboardRequest',
} as const;

export type CompanyOnboardRequest = {
  id: string;
  state: CompanyOnboardRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyOnboardRequestStateChangedReason;
  type: CompanyOnboardRequestType;
};

export type CompanyCloseRequestState = typeof CompanyCloseRequestState[keyof typeof CompanyCloseRequestState];


export const CompanyCloseRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyCloseRequestStateChangedReason = { [key: string]: unknown };

export type CompanyCloseRequestType = typeof CompanyCloseRequestType[keyof typeof CompanyCloseRequestType];


export const CompanyCloseRequestType = {
  CompanyCloseRequest: 'CompanyCloseRequest',
} as const;

export type CompanyCloseRequest = {
  id: string;
  state: CompanyCloseRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyCloseRequestStateChangedReason;
  type: CompanyCloseRequestType;
};

export type AccountCreateRequestState = typeof AccountCreateRequestState[keyof typeof AccountCreateRequestState];


export const AccountCreateRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type AccountCreateRequestStateChangedReason = { [key: string]: unknown };

export type AccountCreateRequestType = typeof AccountCreateRequestType[keyof typeof AccountCreateRequestType];


export const AccountCreateRequestType = {
  AccountCreateRequest: 'AccountCreateRequest',
} as const;

export type AccountCreateRequest = {
  id: string;
  state: AccountCreateRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: AccountCreateRequestStateChangedReason;
  type: AccountCreateRequestType;
};

export type CompanyUpdateDocsRequestState = typeof CompanyUpdateDocsRequestState[keyof typeof CompanyUpdateDocsRequestState];


export const CompanyUpdateDocsRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyUpdateDocsRequestStateChangedReason = { [key: string]: unknown };

export type CompanyUpdateDocsRequestType = typeof CompanyUpdateDocsRequestType[keyof typeof CompanyUpdateDocsRequestType];


export const CompanyUpdateDocsRequestType = {
  CompanyUpdateDocsRequest: 'CompanyUpdateDocsRequest',
} as const;

export type CompanyUpdateDocsRequest = {
  id: string;
  state: CompanyUpdateDocsRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyUpdateDocsRequestStateChangedReason;
  type: CompanyUpdateDocsRequestType;
};

export type CompanyUpdateRequestState = typeof CompanyUpdateRequestState[keyof typeof CompanyUpdateRequestState];


export const CompanyUpdateRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyUpdateRequestStateChangedReason = { [key: string]: unknown };

export type CompanyUpdateRequestType = typeof CompanyUpdateRequestType[keyof typeof CompanyUpdateRequestType];


export const CompanyUpdateRequestType = {
  CompanyUpdateRequest: 'CompanyUpdateRequest',
} as const;

export type CompanyUpdateRequest = {
  id: string;
  state: CompanyUpdateRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyUpdateRequestStateChangedReason;
  type: CompanyUpdateRequestType;
};

export type JoinArApprovalRequestState = typeof JoinArApprovalRequestState[keyof typeof JoinArApprovalRequestState];


export const JoinArApprovalRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type JoinArApprovalRequestStateChangedReason = { [key: string]: unknown };

export type JoinArApprovalRequestType = typeof JoinArApprovalRequestType[keyof typeof JoinArApprovalRequestType];


export const JoinArApprovalRequestType = {
  JoinArApprovalRequest: 'JoinArApprovalRequest',
} as const;

export type JoinArApprovalRequest = {
  id: string;
  state: JoinArApprovalRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: JoinArApprovalRequestStateChangedReason;
  type: JoinArApprovalRequestType;
};

export type IssueApprovalRequestState = typeof IssueApprovalRequestState[keyof typeof IssueApprovalRequestState];


export const IssueApprovalRequestState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type IssueApprovalRequestStateChangedReason = { [key: string]: unknown };

export type IssueApprovalRequestType = typeof IssueApprovalRequestType[keyof typeof IssueApprovalRequestType];


export const IssueApprovalRequestType = {
  IssueApprovalRequest: 'IssueApprovalRequest',
} as const;

export type IssueApprovalRequest = {
  id: string;
  state: IssueApprovalRequestState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: IssueApprovalRequestStateChangedReason;
  type: IssueApprovalRequestType;
};

export type PendingApprovalRequests = {
  approvalRequests: (JoinCrApprovalRequest | CrDataApprovalRequest | CompanyCreateRequest | AccountDetailsChangeRequest | CompanyOnboardRequest | CompanyCloseRequest | AccountCreateRequest | CompanyUpdateDocsRequest | CompanyUpdateRequest | JoinArApprovalRequest | IssueApprovalRequest)[];
};

export type GetPendingActionsResponse = {
  pendingSignature: QueryUnitProcessResponse;
  pendingAcceptance: QueryUnitProcessResponse;
  pendingApproval: PendingApprovalRequests;
};

export type CountryResponse = {
  name: string;
  code: string;
  phoneCode: string;
};

export type ApprovalType = typeof ApprovalType[keyof typeof ApprovalType];


export const ApprovalType = {
  JoinCrApprovalRequest: 'JoinCrApprovalRequest',
  CrDataApprovalRequest: 'CrDataApprovalRequest',
  CompanyCreateRequest: 'CompanyCreateRequest',
  AccountDetailsChangeRequest: 'AccountDetailsChangeRequest',
  CompanyOnboardRequest: 'CompanyOnboardRequest',
  CompanyCloseRequest: 'CompanyCloseRequest',
  AccountCreateRequest: 'AccountCreateRequest',
  CompanyUpdateDocsRequest: 'CompanyUpdateDocsRequest',
  CompanyUpdateRequest: 'CompanyUpdateRequest',
  JoinArApprovalRequest: 'JoinArApprovalRequest',
  IssueApprovalRequest: 'IssueApprovalRequest',
} as const;

export type ApprovalState = typeof ApprovalState[keyof typeof ApprovalState];


export const ApprovalState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CrApprovalRequestCompanyPayload = {
  id: string;
  name: string;
};

export type JoinCrApprovalRequestPayload = {
  userId: string;
  userEmail: string;
  userDetails: UserDetailsDTO;
  companies: CrApprovalRequestCompanyPayload[];
  kycResult: boolean;
  kycApplicantUrl: string;
};

export type JoinCrApprovalRequestWithPayloadState = typeof JoinCrApprovalRequestWithPayloadState[keyof typeof JoinCrApprovalRequestWithPayloadState];


export const JoinCrApprovalRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type JoinCrApprovalRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type JoinCrApprovalRequestWithPayloadType = typeof JoinCrApprovalRequestWithPayloadType[keyof typeof JoinCrApprovalRequestWithPayloadType];


export const JoinCrApprovalRequestWithPayloadType = {
  JoinCrApprovalRequest: 'JoinCrApprovalRequest',
} as const;

export type JoinCrApprovalRequestWithPayload = {
  id: string;
  state: JoinCrApprovalRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: JoinCrApprovalRequestWithPayloadStateChangedReason;
  type: JoinCrApprovalRequestWithPayloadType;
  payload: JoinCrApprovalRequestPayload;
};

export type CrDataApprovalRequestPayload = {
  userId: string;
  userEmail: string;
  userDetails: UserDetailsDTO;
  companies: CrApprovalRequestCompanyPayload[];
};

export type CrDataApprovalRequestWithPayloadState = typeof CrDataApprovalRequestWithPayloadState[keyof typeof CrDataApprovalRequestWithPayloadState];


export const CrDataApprovalRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CrDataApprovalRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CrDataApprovalRequestWithPayloadType = typeof CrDataApprovalRequestWithPayloadType[keyof typeof CrDataApprovalRequestWithPayloadType];


export const CrDataApprovalRequestWithPayloadType = {
  CrDataApprovalRequest: 'CrDataApprovalRequest',
} as const;

export type CrDataApprovalRequestWithPayload = {
  id: string;
  state: CrDataApprovalRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CrDataApprovalRequestWithPayloadStateChangedReason;
  type: CrDataApprovalRequestWithPayloadType;
  payload: CrDataApprovalRequestPayload;
};

export type CompanyCreatePayload = {
  companyDetails: CompanyDetailsResponse;
  userDetails: UserDetailsDTO;
  userEmail: string;
  userId: string;
};

export type CompanyCreateRequestWithPayloadState = typeof CompanyCreateRequestWithPayloadState[keyof typeof CompanyCreateRequestWithPayloadState];


export const CompanyCreateRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyCreateRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CompanyCreateRequestWithPayloadType = typeof CompanyCreateRequestWithPayloadType[keyof typeof CompanyCreateRequestWithPayloadType];


export const CompanyCreateRequestWithPayloadType = {
  CompanyCreateRequest: 'CompanyCreateRequest',
} as const;

export type CompanyCreateRequestWithPayload = {
  id: string;
  state: CompanyCreateRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyCreateRequestWithPayloadStateChangedReason;
  type: CompanyCreateRequestWithPayloadType;
  payload: CompanyCreatePayload;
};

export type AccountDetailsChangePayloadType = typeof AccountDetailsChangePayloadType[keyof typeof AccountDetailsChangePayloadType];


export const AccountDetailsChangePayloadType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type AccountDetailsChangePayload = {
  id: string;
  type: AccountDetailsChangePayloadType;
  documents: string[];
  name: string;
};

export type AccountDetailsChangeRequestWithPayloadState = typeof AccountDetailsChangeRequestWithPayloadState[keyof typeof AccountDetailsChangeRequestWithPayloadState];


export const AccountDetailsChangeRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type AccountDetailsChangeRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type AccountDetailsChangeRequestWithPayloadType = typeof AccountDetailsChangeRequestWithPayloadType[keyof typeof AccountDetailsChangeRequestWithPayloadType];


export const AccountDetailsChangeRequestWithPayloadType = {
  AccountDetailsChangeRequest: 'AccountDetailsChangeRequest',
} as const;

export type AccountDetailsChangeRequestWithPayload = {
  id: string;
  state: AccountDetailsChangeRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: AccountDetailsChangeRequestWithPayloadStateChangedReason;
  type: AccountDetailsChangeRequestWithPayloadType;
  payload: AccountDetailsChangePayload;
};

export type CompanyOnboardingApprovalPayload = {
  companyDetails: CompanyDetailsResponse;
  userDetails: UserDetailsDTO;
  userEmail: string;
  userId: string;
  isVerificationPositive: boolean;
  verificationApplicantUrl: string;
};

export type CompanyOnboardRequestWithPayloadState = typeof CompanyOnboardRequestWithPayloadState[keyof typeof CompanyOnboardRequestWithPayloadState];


export const CompanyOnboardRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyOnboardRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CompanyOnboardRequestWithPayloadType = typeof CompanyOnboardRequestWithPayloadType[keyof typeof CompanyOnboardRequestWithPayloadType];


export const CompanyOnboardRequestWithPayloadType = {
  CompanyOnboardRequest: 'CompanyOnboardRequest',
} as const;

export type CompanyOnboardRequestWithPayload = {
  id: string;
  state: CompanyOnboardRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyOnboardRequestWithPayloadStateChangedReason;
  type: CompanyOnboardRequestWithPayloadType;
  payload: CompanyOnboardingApprovalPayload;
};

export type CompanyClosePayload = {
  companyId: string;
};

export type CompanyCloseRequestWithPayloadState = typeof CompanyCloseRequestWithPayloadState[keyof typeof CompanyCloseRequestWithPayloadState];


export const CompanyCloseRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyCloseRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CompanyCloseRequestWithPayloadType = typeof CompanyCloseRequestWithPayloadType[keyof typeof CompanyCloseRequestWithPayloadType];


export const CompanyCloseRequestWithPayloadType = {
  CompanyCloseRequest: 'CompanyCloseRequest',
} as const;

export type CompanyCloseRequestWithPayload = {
  id: string;
  state: CompanyCloseRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyCloseRequestWithPayloadStateChangedReason;
  type: CompanyCloseRequestWithPayloadType;
  payload: CompanyClosePayload;
};

export type AccountCreatePayload = {
  id: string;
};

export type AccountCreateRequestWithPayloadState = typeof AccountCreateRequestWithPayloadState[keyof typeof AccountCreateRequestWithPayloadState];


export const AccountCreateRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type AccountCreateRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type AccountCreateRequestWithPayloadType = typeof AccountCreateRequestWithPayloadType[keyof typeof AccountCreateRequestWithPayloadType];


export const AccountCreateRequestWithPayloadType = {
  AccountCreateRequest: 'AccountCreateRequest',
} as const;

export type AccountCreateRequestWithPayload = {
  id: string;
  state: AccountCreateRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: AccountCreateRequestWithPayloadStateChangedReason;
  type: AccountCreateRequestWithPayloadType;
  payload: AccountCreatePayload;
};

export type CompanyUpdateDocsPayload = {
  companyId: string;
  uploads: string[];
};

export type CompanyUpdateDocsRequestWithPayloadState = typeof CompanyUpdateDocsRequestWithPayloadState[keyof typeof CompanyUpdateDocsRequestWithPayloadState];


export const CompanyUpdateDocsRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyUpdateDocsRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CompanyUpdateDocsRequestWithPayloadType = typeof CompanyUpdateDocsRequestWithPayloadType[keyof typeof CompanyUpdateDocsRequestWithPayloadType];


export const CompanyUpdateDocsRequestWithPayloadType = {
  CompanyUpdateDocsRequest: 'CompanyUpdateDocsRequest',
} as const;

export type CompanyUpdateDocsRequestWithPayload = {
  id: string;
  state: CompanyUpdateDocsRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyUpdateDocsRequestWithPayloadStateChangedReason;
  type: CompanyUpdateDocsRequestWithPayloadType;
  payload: CompanyUpdateDocsPayload;
};

export type Country = { [key: string]: unknown };

export type CompanyUpdateDetailsPayload = {
  name: string;
  country: Country;
  state: string;
  city: string;
  postcode: string;
  address: string;
  address2: string;
  address3: string;
  website: string;
};

export type CompanyUpdatePayload = {
  companyId: string;
  details: CompanyUpdateDetailsPayload;
};

export type CompanyUpdateRequestWithPayloadState = typeof CompanyUpdateRequestWithPayloadState[keyof typeof CompanyUpdateRequestWithPayloadState];


export const CompanyUpdateRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type CompanyUpdateRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type CompanyUpdateRequestWithPayloadType = typeof CompanyUpdateRequestWithPayloadType[keyof typeof CompanyUpdateRequestWithPayloadType];


export const CompanyUpdateRequestWithPayloadType = {
  CompanyUpdateRequest: 'CompanyUpdateRequest',
} as const;

export type CompanyUpdateRequestWithPayload = {
  id: string;
  state: CompanyUpdateRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: CompanyUpdateRequestWithPayloadStateChangedReason;
  type: CompanyUpdateRequestWithPayloadType;
  payload: CompanyUpdatePayload;
};

export type AccountMembership = {
  accountId: string;
  accountName: string;
  accountMembershipRole: AccountMembershipRole;
};

export type JoinArApprovalRequestPayload = {
  userId: string;
  userDetails: UserDetailsDTO;
  accountsMembership: AccountMembership[];
  userEmail: string;
};

export type JoinArApprovalRequestWithPayloadState = typeof JoinArApprovalRequestWithPayloadState[keyof typeof JoinArApprovalRequestWithPayloadState];


export const JoinArApprovalRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type JoinArApprovalRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type JoinArApprovalRequestWithPayloadType = typeof JoinArApprovalRequestWithPayloadType[keyof typeof JoinArApprovalRequestWithPayloadType];


export const JoinArApprovalRequestWithPayloadType = {
  JoinArApprovalRequest: 'JoinArApprovalRequest',
} as const;

export type JoinArApprovalRequestWithPayload = {
  id: string;
  state: JoinArApprovalRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: JoinArApprovalRequestWithPayloadStateChangedReason;
  type: JoinArApprovalRequestWithPayloadType;
  payload: JoinArApprovalRequestPayload;
};

export type IssueApprovalPayloadMetadata = { [key: string]: unknown };

export type IssueApprovalPayload = {
  processId: string;
  accountId: string;
  metadata: IssueApprovalPayloadMetadata;
};

export type IssueApprovalRequestWithPayloadState = typeof IssueApprovalRequestWithPayloadState[keyof typeof IssueApprovalRequestWithPayloadState];


export const IssueApprovalRequestWithPayloadState = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  closed: 'closed',
} as const;

export type IssueApprovalRequestWithPayloadStateChangedReason = { [key: string]: unknown };

export type IssueApprovalRequestWithPayloadType = typeof IssueApprovalRequestWithPayloadType[keyof typeof IssueApprovalRequestWithPayloadType];


export const IssueApprovalRequestWithPayloadType = {
  IssueApprovalRequest: 'IssueApprovalRequest',
} as const;

export type IssueApprovalRequestWithPayload = {
  id: string;
  state: IssueApprovalRequestWithPayloadState;
  name: string;
  createdAt: string;
  stateChangedAt: string;
  stateChangedReason: IssueApprovalRequestWithPayloadStateChangedReason;
  type: IssueApprovalRequestWithPayloadType;
  payload: IssueApprovalPayload;
};

export type GetWithPayloadResponse = {
  approval: JoinCrApprovalRequestWithPayload | CrDataApprovalRequestWithPayload | CompanyCreateRequestWithPayload | AccountDetailsChangeRequestWithPayload | CompanyOnboardRequestWithPayload | CompanyCloseRequestWithPayload | AccountCreateRequestWithPayload | CompanyUpdateDocsRequestWithPayload | CompanyUpdateRequestWithPayload | JoinArApprovalRequestWithPayload | IssueApprovalRequestWithPayload;
};

export type JoinCrApprovalRequestApproveRequestType = typeof JoinCrApprovalRequestApproveRequestType[keyof typeof JoinCrApprovalRequestApproveRequestType];


export const JoinCrApprovalRequestApproveRequestType = {
  JoinCrApprovalRequest: 'JoinCrApprovalRequest',
} as const;

export type JoinCrApprovalRequestApproveRequest = {
  type: JoinCrApprovalRequestApproveRequestType;
};

export type CrDataApprovalRequestApproveRequestType = typeof CrDataApprovalRequestApproveRequestType[keyof typeof CrDataApprovalRequestApproveRequestType];


export const CrDataApprovalRequestApproveRequestType = {
  CrDataApprovalRequest: 'CrDataApprovalRequest',
} as const;

export type CrDataApprovalRequestApproveRequest = {
  type: CrDataApprovalRequestApproveRequestType;
};

export type CompanyCreateRequestApproveRequestType = typeof CompanyCreateRequestApproveRequestType[keyof typeof CompanyCreateRequestApproveRequestType];


export const CompanyCreateRequestApproveRequestType = {
  CompanyCreateRequest: 'CompanyCreateRequest',
} as const;

export type CompanyCreateRequestApproveRequest = {
  type: CompanyCreateRequestApproveRequestType;
};

export type AccountDetailsChangeRequestApproveRequestType = typeof AccountDetailsChangeRequestApproveRequestType[keyof typeof AccountDetailsChangeRequestApproveRequestType];


export const AccountDetailsChangeRequestApproveRequestType = {
  AccountDetailsChangeRequest: 'AccountDetailsChangeRequest',
} as const;

export type AccountDetailsChangeRequestApproveRequest = {
  type: AccountDetailsChangeRequestApproveRequestType;
};

export type CompanyOnboardRequestApproveRequestType = typeof CompanyOnboardRequestApproveRequestType[keyof typeof CompanyOnboardRequestApproveRequestType];


export const CompanyOnboardRequestApproveRequestType = {
  CompanyOnboardRequest: 'CompanyOnboardRequest',
} as const;

export type CompanyOnboardRequestApproveRequest = {
  type: CompanyOnboardRequestApproveRequestType;
};

export type CompanyCloseRequestApproveRequestType = typeof CompanyCloseRequestApproveRequestType[keyof typeof CompanyCloseRequestApproveRequestType];


export const CompanyCloseRequestApproveRequestType = {
  CompanyCloseRequest: 'CompanyCloseRequest',
} as const;

export type CompanyCloseRequestApproveRequest = {
  type: CompanyCloseRequestApproveRequestType;
};

export type AccountCreateRequestApproveRequestType = typeof AccountCreateRequestApproveRequestType[keyof typeof AccountCreateRequestApproveRequestType];


export const AccountCreateRequestApproveRequestType = {
  AccountCreateRequest: 'AccountCreateRequest',
} as const;

export type AccountCreateRequestApproveRequest = {
  type: AccountCreateRequestApproveRequestType;
};

export type CompanyUpdateDocsRequestApproveRequestType = typeof CompanyUpdateDocsRequestApproveRequestType[keyof typeof CompanyUpdateDocsRequestApproveRequestType];


export const CompanyUpdateDocsRequestApproveRequestType = {
  CompanyUpdateDocsRequest: 'CompanyUpdateDocsRequest',
} as const;

export type CompanyUpdateDocsRequestApproveRequest = {
  type: CompanyUpdateDocsRequestApproveRequestType;
};

export type CompanyUpdateRequestApproveRequestType = typeof CompanyUpdateRequestApproveRequestType[keyof typeof CompanyUpdateRequestApproveRequestType];


export const CompanyUpdateRequestApproveRequestType = {
  CompanyUpdateRequest: 'CompanyUpdateRequest',
} as const;

export type CompanyUpdateRequestApproveRequest = {
  type: CompanyUpdateRequestApproveRequestType;
};

export type JoinArApprovalRequestApproveRequestType = typeof JoinArApprovalRequestApproveRequestType[keyof typeof JoinArApprovalRequestApproveRequestType];


export const JoinArApprovalRequestApproveRequestType = {
  JoinArApprovalRequest: 'JoinArApprovalRequest',
} as const;

export type JoinArApprovalRequestApproveRequest = {
  type: JoinArApprovalRequestApproveRequestType;
};

export type IssueApprovalRequestApproveRequestMetadata = { [key: string]: unknown };

export type IssueApprovalRequestApproveRequestType = typeof IssueApprovalRequestApproveRequestType[keyof typeof IssueApprovalRequestApproveRequestType];


export const IssueApprovalRequestApproveRequestType = {
  IssueApprovalRequest: 'IssueApprovalRequest',
} as const;

export type IssueApprovalRequestApproveRequest = {
  metadata: IssueApprovalRequestApproveRequestMetadata;
  type: IssueApprovalRequestApproveRequestType;
};

export type ApproveRequest = {
  payload: JoinCrApprovalRequestApproveRequest | CrDataApprovalRequestApproveRequest | CompanyCreateRequestApproveRequest | AccountDetailsChangeRequestApproveRequest | CompanyOnboardRequestApproveRequest | CompanyCloseRequestApproveRequest | AccountCreateRequestApproveRequest | CompanyUpdateDocsRequestApproveRequest | CompanyUpdateRequestApproveRequest | JoinArApprovalRequestApproveRequest | IssueApprovalRequestApproveRequest;
};

export type RejectRequest = {
  reason: string;
};

export type CloseRequest = {
  reason: string;
};

export type UserResponse = {
  id: string;
  name: string;
  email: string;
};

export type AddRegistryAdminRequest = {
  emails: string[];
};

export type UnitViewSearchType = typeof UnitViewSearchType[keyof typeof UnitViewSearchType];


export const UnitViewSearchType = {
  Issue: 'Issue',
  Claim: 'Claim',
  Holdings: 'Holdings',
} as const;

export type UnitViewSortBy = typeof UnitViewSortBy[keyof typeof UnitViewSortBy];


export const UnitViewSortBy = {
  unitType: 'unitType',
  id: 'id',
  issuanceDate: 'issuanceDate',
  volume: 'volume',
  free_volume: 'free_volume',
  status: 'status',
  expirationDate: 'expirationDate',
  co2Abated: 'co2Abated',
  freeCo2Abated: 'freeCo2Abated',
  airTransportProviderBeneficiary: 'airTransportProviderBeneficiary',
  endUserBeneficiary: 'endUserBeneficiary',
  logisticsProviderBeneficiary: 'logisticsProviderBeneficiary',
  productionYear: 'productionYear',
  typeCode: 'typeCode',
  fuelProducingCompanyName: 'fuelProducingCompanyName',
  carbonIntensityScore: 'carbonIntensityScore',
  feedstockCountries: 'feedstockCountries',
  certificationScheme: 'certificationScheme',
  productionFeedstock: 'productionFeedstock',
  created_at: 'created_at',
  retiredAt: 'retiredAt',
  SAFcAClaimBeneficiaryCompanyName: 'SAFcAClaimBeneficiaryCompanyName',
  SAFcEClaimBeneficiaryCompanyName: 'SAFcEClaimBeneficiaryCompanyName',
  logisticsProviderBeneficiaryCompanyName: 'logisticsProviderBeneficiaryCompanyName',
} as const;

export type FilterDTO = {
  unitTypeCodeType?: string[];
  assuranceLevel?: string[];
  usabilityTier?: string[];
  sustainabilityTier?: string[];
  /**
     * Instead of using history and unitStatus=active filter, use ?type=Holdings
     * @deprecated
     */
  unitStatus?: string[];
};

export type UnitResponseItemComputed = { [key: string]: unknown };

export type UnitResponseItemMetadata = { [key: string]: unknown };

export type UnitResponseItem = {
  id: string;
  rootId: string;
  volume: number;
  lockedVolume: number;
  freeVolume: number;
  ownerId: string;
  isLast: boolean;
  computed: UnitResponseItemComputed;
  metadata: UnitResponseItemMetadata;
  type: UnitType;
  status: UnitStatus;
  note: string;
};

export type UnitResponse = {
  count: number;
  items: UnitResponseItem[];
};

export type SetNoteRequest = {
  note: string;
};

export type ExportRequestField = {
  name: string;
  path: string;
};

export type ExportRequestUnitType = typeof ExportRequestUnitType[keyof typeof ExportRequestUnitType];


export const ExportRequestUnitType = {
  SAFcA: 'SAFcA',
  SAFcE: 'SAFcE',
} as const;

export type ExportRequestOrder = typeof ExportRequestOrder[keyof typeof ExportRequestOrder];


export const ExportRequestOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ExportRequest = {
  limit?: number;
  offset?: number;
  type?: UnitViewSearchType;
  unitType?: ExportRequestUnitType;
  unitIds?: string[];
  sortBy?: UnitViewSortBy;
  order?: ExportRequestOrder;
  search?: string;
  filters?: FilterDTO;
  /** @deprecated */
  history?: boolean;
  ownerIds: string[];
  fields?: ExportRequestField[];
  fileName?: string;
};

export type BlockUnitRequest = {
  reason?: string;
};

export type UnblockUnitRequest = {
  reason?: string;
};

export type CreateTicketRequestType = typeof CreateTicketRequestType[keyof typeof CreateTicketRequestType];


export const CreateTicketRequestType = {
  technicalIssue: 'technicalIssue',
  otherIssues: 'otherIssues',
  suggestion: 'suggestion',
} as const;

export type CreateTicketRequest = {
  type: CreateTicketRequestType;
  description: string;
  url: string;
  screenshots: (Blob | File)[];
};

export type QueryUnitProcessState = typeof QueryUnitProcessState[keyof typeof QueryUnitProcessState];


export const QueryUnitProcessState = {
  pending: 'pending',
  finished: 'finished',
} as const;

export type GetUnitProcessByIdResponse = {
  process: IssueProcessDTO | TransferProcessDTO | ClaimProcessDTO | IssueNewTreeProcessDTO | SplitProcessDTO;
};

export type ProcessExportRequest = {
  processIds?: string[];
  state: QueryUnitProcessState;
  fields: ExportRequestField[];
  fileName?: string;
  search?: string;
};

export type OperationResponse = {
  operationId: string;
};

/**
 * Payload of the successful transfer
 */
export type TransferResultPayload = { [key: string]: unknown };

export type TransferResult = {
  /** Payload of the successful transfer */
  payload: TransferResultPayload;
  /** Process ID of the successful transfer */
  processId: string;
};

/**
 * Payload of the successful transfer
 */
export type TransferErrorPayload = { [key: string]: unknown };

export type TransferError = {
  /** Payload of the successful transfer */
  payload: TransferErrorPayload;
  /** Error of failed transfer */
  error: string;
};

export type BatchTransferResponse = {
  /** List of successful transfers */
  successful: TransferResult[];
  /** List of failed transfers */
  failed: TransferError[];
};

export type ClaimAcceptanceAcceptRequestClaimPurpose = typeof ClaimAcceptanceAcceptRequestClaimPurpose[keyof typeof ClaimAcceptanceAcceptRequestClaimPurpose];


export const ClaimAcceptanceAcceptRequestClaimPurpose = {
  domestic: 'domestic',
  international: 'international',
} as const;

export type ClaimAcceptanceAcceptRequest = {
  claimPurpose?: ClaimAcceptanceAcceptRequestClaimPurpose;
};

export type AccountRepRemovalSucceededType = typeof AccountRepRemovalSucceededType[keyof typeof AccountRepRemovalSucceededType];


export const AccountRepRemovalSucceededType = {
  AccountRepRemovalSucceeded: 'AccountRepRemovalSucceeded',
} as const;

export type AccountRepRemovalSucceeded = {
  id: number;
  type: AccountRepRemovalSucceededType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountUpdatedType = typeof AccountUpdatedType[keyof typeof AccountUpdatedType];


export const AccountUpdatedType = {
  AccountUpdated: 'AccountUpdated',
} as const;

export type AccountUpdated = {
  id: number;
  type: AccountUpdatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountClosedType = typeof AccountClosedType[keyof typeof AccountClosedType];


export const AccountClosedType = {
  AccountClosed: 'AccountClosed',
} as const;

export type AccountClosed = {
  id: number;
  type: AccountClosedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountBlockedType = typeof AccountBlockedType[keyof typeof AccountBlockedType];


export const AccountBlockedType = {
  AccountBlocked: 'AccountBlocked',
} as const;

export type AccountBlocked = {
  id: number;
  type: AccountBlockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountUnblockedType = typeof AccountUnblockedType[keyof typeof AccountUnblockedType];


export const AccountUnblockedType = {
  AccountUnblocked: 'AccountUnblocked',
} as const;

export type AccountUnblocked = {
  id: number;
  type: AccountUnblockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountMembershipAddedType = typeof AccountMembershipAddedType[keyof typeof AccountMembershipAddedType];


export const AccountMembershipAddedType = {
  AccountMembershipAdded: 'AccountMembershipAdded',
} as const;

export type AccountMembershipAdded = {
  id: number;
  type: AccountMembershipAddedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type MembershipRoleChangedType = typeof MembershipRoleChangedType[keyof typeof MembershipRoleChangedType];


export const MembershipRoleChangedType = {
  MembershipRoleChanged: 'MembershipRoleChanged',
} as const;

export type MembershipRoleChanged = {
  id: number;
  type: MembershipRoleChangedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountCreatedType = typeof AccountCreatedType[keyof typeof AccountCreatedType];


export const AccountCreatedType = {
  AccountCreated: 'AccountCreated',
} as const;

export type AccountCreated = {
  id: number;
  type: AccountCreatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type TrustedRecipientAddedType = typeof TrustedRecipientAddedType[keyof typeof TrustedRecipientAddedType];


export const TrustedRecipientAddedType = {
  TrustedRecipientAdded: 'TrustedRecipientAdded',
} as const;

export type TrustedRecipientAdded = {
  id: number;
  type: TrustedRecipientAddedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type TrustedRecipientRemovedType = typeof TrustedRecipientRemovedType[keyof typeof TrustedRecipientRemovedType];


export const TrustedRecipientRemovedType = {
  TrustedRecipientRemoved: 'TrustedRecipientRemoved',
} as const;

export type TrustedRecipientRemoved = {
  id: number;
  type: TrustedRecipientRemovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountUpdateRejectedType = typeof AccountUpdateRejectedType[keyof typeof AccountUpdateRejectedType];


export const AccountUpdateRejectedType = {
  AccountUpdateRejected: 'AccountUpdateRejected',
} as const;

export type AccountUpdateRejected = {
  id: number;
  type: AccountUpdateRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountUpdateApprovedType = typeof AccountUpdateApprovedType[keyof typeof AccountUpdateApprovedType];


export const AccountUpdateApprovedType = {
  AccountUpdateApproved: 'AccountUpdateApproved',
} as const;

export type AccountUpdateApproved = {
  id: number;
  type: AccountUpdateApprovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountCreationApprovedType = typeof AccountCreationApprovedType[keyof typeof AccountCreationApprovedType];


export const AccountCreationApprovedType = {
  AccountCreationApproved: 'AccountCreationApproved',
} as const;

export type AccountCreationApproved = {
  id: number;
  type: AccountCreationApprovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type AccountCreationRejectedType = typeof AccountCreationRejectedType[keyof typeof AccountCreationRejectedType];


export const AccountCreationRejectedType = {
  AccountCreationRejected: 'AccountCreationRejected',
} as const;

export type AccountCreationRejected = {
  id: number;
  type: AccountCreationRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UserRemovalSucceededType = typeof UserRemovalSucceededType[keyof typeof UserRemovalSucceededType];


export const UserRemovalSucceededType = {
  UserRemovalSucceeded: 'UserRemovalSucceeded',
} as const;

export type UserRemovalSucceeded = {
  id: number;
  type: UserRemovalSucceededType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UserBlockedType = typeof UserBlockedType[keyof typeof UserBlockedType];


export const UserBlockedType = {
  UserBlocked: 'UserBlocked',
} as const;

export type UserBlocked = {
  id: number;
  type: UserBlockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UserUnblockedType = typeof UserUnblockedType[keyof typeof UserUnblockedType];


export const UserUnblockedType = {
  UserUnblocked: 'UserUnblocked',
} as const;

export type UserUnblocked = {
  id: number;
  type: UserUnblockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UserInfoUpdatedType = typeof UserInfoUpdatedType[keyof typeof UserInfoUpdatedType];


export const UserInfoUpdatedType = {
  UserInfoUpdated: 'UserInfoUpdated',
} as const;

export type UserInfoUpdated = {
  id: number;
  type: UserInfoUpdatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ApprovalApprovedType = typeof ApprovalApprovedType[keyof typeof ApprovalApprovedType];


export const ApprovalApprovedType = {
  ApprovalApproved: 'ApprovalApproved',
} as const;

export type ApprovalApproved = {
  id: number;
  type: ApprovalApprovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ApprovalClosedType = typeof ApprovalClosedType[keyof typeof ApprovalClosedType];


export const ApprovalClosedType = {
  ApprovalClosed: 'ApprovalClosed',
} as const;

export type ApprovalClosed = {
  id: number;
  type: ApprovalClosedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ApprovalRejectedType = typeof ApprovalRejectedType[keyof typeof ApprovalRejectedType];


export const ApprovalRejectedType = {
  ApprovalRejected: 'ApprovalRejected',
} as const;

export type ApprovalRejected = {
  id: number;
  type: ApprovalRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyUserRemovalSucceededType = typeof CompanyUserRemovalSucceededType[keyof typeof CompanyUserRemovalSucceededType];


export const CompanyUserRemovalSucceededType = {
  CompanyUserRemovalSucceeded: 'CompanyUserRemovalSucceeded',
} as const;

export type CompanyUserRemovalSucceeded = {
  id: number;
  type: CompanyUserRemovalSucceededType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyUpdatedType = typeof CompanyUpdatedType[keyof typeof CompanyUpdatedType];


export const CompanyUpdatedType = {
  CompanyUpdated: 'CompanyUpdated',
} as const;

export type CompanyUpdated = {
  id: number;
  type: CompanyUpdatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyClosedType = typeof CompanyClosedType[keyof typeof CompanyClosedType];


export const CompanyClosedType = {
  CompanyClosed: 'CompanyClosed',
} as const;

export type CompanyClosed = {
  id: number;
  type: CompanyClosedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyBlockedType = typeof CompanyBlockedType[keyof typeof CompanyBlockedType];


export const CompanyBlockedType = {
  CompanyBlocked: 'CompanyBlocked',
} as const;

export type CompanyBlocked = {
  id: number;
  type: CompanyBlockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyUnblockedType = typeof CompanyUnblockedType[keyof typeof CompanyUnblockedType];


export const CompanyUnblockedType = {
  CompanyUnblocked: 'CompanyUnblocked',
} as const;

export type CompanyUnblocked = {
  id: number;
  type: CompanyUnblockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyUpdateDocsRequestedType = typeof CompanyUpdateDocsRequestedType[keyof typeof CompanyUpdateDocsRequestedType];


export const CompanyUpdateDocsRequestedType = {
  CompanyUpdateDocsRequested: 'CompanyUpdateDocsRequested',
} as const;

export type CompanyUpdateDocsRequested = {
  id: number;
  type: CompanyUpdateDocsRequestedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyAwaitingReviewType = typeof CompanyAwaitingReviewType[keyof typeof CompanyAwaitingReviewType];


export const CompanyAwaitingReviewType = {
  CompanyAwaitingReview: 'CompanyAwaitingReview',
} as const;

export type CompanyAwaitingReview = {
  id: number;
  type: CompanyAwaitingReviewType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyActiveType = typeof CompanyActiveType[keyof typeof CompanyActiveType];


export const CompanyActiveType = {
  CompanyActive: 'CompanyActive',
} as const;

export type CompanyActive = {
  id: number;
  type: CompanyActiveType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyRemovedType = typeof CompanyRemovedType[keyof typeof CompanyRemovedType];


export const CompanyRemovedType = {
  CompanyRemoved: 'CompanyRemoved',
} as const;

export type CompanyRemoved = {
  id: number;
  type: CompanyRemovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyMembershipAddedType = typeof CompanyMembershipAddedType[keyof typeof CompanyMembershipAddedType];


export const CompanyMembershipAddedType = {
  CompanyMembershipAdded: 'CompanyMembershipAdded',
} as const;

export type CompanyMembershipAdded = {
  id: number;
  type: CompanyMembershipAddedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyMembershipChangedType = typeof CompanyMembershipChangedType[keyof typeof CompanyMembershipChangedType];


export const CompanyMembershipChangedType = {
  CompanyMembershipChanged: 'CompanyMembershipChanged',
} as const;

export type CompanyMembershipChanged = {
  id: number;
  type: CompanyMembershipChangedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ArOnboardingCreatedType = typeof ArOnboardingCreatedType[keyof typeof ArOnboardingCreatedType];


export const ArOnboardingCreatedType = {
  ArOnboardingCreated: 'ArOnboardingCreated',
} as const;

export type ArOnboardingCreated = {
  id: number;
  type: ArOnboardingCreatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ArOnboardingRevokedType = typeof ArOnboardingRevokedType[keyof typeof ArOnboardingRevokedType];


export const ArOnboardingRevokedType = {
  ArOnboardingRevoked: 'ArOnboardingRevoked',
} as const;

export type ArOnboardingRevoked = {
  id: number;
  type: ArOnboardingRevokedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type ArOnboardingRejectedType = typeof ArOnboardingRejectedType[keyof typeof ArOnboardingRejectedType];


export const ArOnboardingRejectedType = {
  ArOnboardingRejected: 'ArOnboardingRejected',
} as const;

export type ArOnboardingRejected = {
  id: number;
  type: ArOnboardingRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CrOnboardingCreatedType = typeof CrOnboardingCreatedType[keyof typeof CrOnboardingCreatedType];


export const CrOnboardingCreatedType = {
  CrOnboardingCreated: 'CrOnboardingCreated',
} as const;

export type CrOnboardingCreated = {
  id: number;
  type: CrOnboardingCreatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CrOnboardingRevokedType = typeof CrOnboardingRevokedType[keyof typeof CrOnboardingRevokedType];


export const CrOnboardingRevokedType = {
  CrOnboardingRevoked: 'CrOnboardingRevoked',
} as const;

export type CrOnboardingRevoked = {
  id: number;
  type: CrOnboardingRevokedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CrOnboardingRejectedType = typeof CrOnboardingRejectedType[keyof typeof CrOnboardingRejectedType];


export const CrOnboardingRejectedType = {
  CrOnboardingRejected: 'CrOnboardingRejected',
} as const;

export type CrOnboardingRejected = {
  id: number;
  type: CrOnboardingRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type RaInvitedType = typeof RaInvitedType[keyof typeof RaInvitedType];


export const RaInvitedType = {
  RaInvited: 'RaInvited',
} as const;

export type RaInvited = {
  id: number;
  type: RaInvitedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type VerificationInitializedType = typeof VerificationInitializedType[keyof typeof VerificationInitializedType];


export const VerificationInitializedType = {
  VerificationInitialized: 'VerificationInitialized',
} as const;

export type VerificationInitialized = {
  id: number;
  type: VerificationInitializedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type VerificationClosedType = typeof VerificationClosedType[keyof typeof VerificationClosedType];


export const VerificationClosedType = {
  VerificationClosed: 'VerificationClosed',
} as const;

export type VerificationClosed = {
  id: number;
  type: VerificationClosedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type VerificationResultHandledType = typeof VerificationResultHandledType[keyof typeof VerificationResultHandledType];


export const VerificationResultHandledType = {
  VerificationResultHandled: 'VerificationResultHandled',
} as const;

export type VerificationResultHandled = {
  id: number;
  type: VerificationResultHandledType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type TicketCreatedType = typeof TicketCreatedType[keyof typeof TicketCreatedType];


export const TicketCreatedType = {
  TicketCreated: 'TicketCreated',
} as const;

export type TicketCreated = {
  id: number;
  type: TicketCreatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessSignatureSignedType = typeof UnitProcessSignatureSignedType[keyof typeof UnitProcessSignatureSignedType];


export const UnitProcessSignatureSignedType = {
  UnitProcessSignatureSigned: 'UnitProcessSignatureSigned',
} as const;

export type UnitProcessSignatureSigned = {
  id: number;
  type: UnitProcessSignatureSignedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessSignatureRejectedType = typeof UnitProcessSignatureRejectedType[keyof typeof UnitProcessSignatureRejectedType];


export const UnitProcessSignatureRejectedType = {
  UnitProcessSignatureRejected: 'UnitProcessSignatureRejected',
} as const;

export type UnitProcessSignatureRejected = {
  id: number;
  type: UnitProcessSignatureRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessAcceptanceAcceptedType = typeof UnitProcessAcceptanceAcceptedType[keyof typeof UnitProcessAcceptanceAcceptedType];


export const UnitProcessAcceptanceAcceptedType = {
  UnitProcessAcceptanceAccepted: 'UnitProcessAcceptanceAccepted',
} as const;

export type UnitProcessAcceptanceAccepted = {
  id: number;
  type: UnitProcessAcceptanceAcceptedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessAcceptanceRejectedType = typeof UnitProcessAcceptanceRejectedType[keyof typeof UnitProcessAcceptanceRejectedType];


export const UnitProcessAcceptanceRejectedType = {
  UnitProcessAcceptanceRejected: 'UnitProcessAcceptanceRejected',
} as const;

export type UnitProcessAcceptanceRejected = {
  id: number;
  type: UnitProcessAcceptanceRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessApprovalApprovedType = typeof UnitProcessApprovalApprovedType[keyof typeof UnitProcessApprovalApprovedType];


export const UnitProcessApprovalApprovedType = {
  UnitProcessApprovalApproved: 'UnitProcessApprovalApproved',
} as const;

export type UnitProcessApprovalApproved = {
  id: number;
  type: UnitProcessApprovalApprovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessApprovalRejectedType = typeof UnitProcessApprovalRejectedType[keyof typeof UnitProcessApprovalRejectedType];


export const UnitProcessApprovalRejectedType = {
  UnitProcessApprovalRejected: 'UnitProcessApprovalRejected',
} as const;

export type UnitProcessApprovalRejected = {
  id: number;
  type: UnitProcessApprovalRejectedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessCancelledType = typeof UnitProcessCancelledType[keyof typeof UnitProcessCancelledType];


export const UnitProcessCancelledType = {
  UnitProcessCancelled: 'UnitProcessCancelled',
} as const;

export type UnitProcessCancelled = {
  id: number;
  type: UnitProcessCancelledType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitProcessInitiatedType = typeof UnitProcessInitiatedType[keyof typeof UnitProcessInitiatedType];


export const UnitProcessInitiatedType = {
  UnitProcessInitiated: 'UnitProcessInitiated',
} as const;

export type UnitProcessInitiated = {
  id: number;
  type: UnitProcessInitiatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type CompanyRemovalRequestedType = typeof CompanyRemovalRequestedType[keyof typeof CompanyRemovalRequestedType];


export const CompanyRemovalRequestedType = {
  CompanyRemovalRequested: 'CompanyRemovalRequested',
} as const;

export type CompanyRemovalRequested = {
  id: number;
  type: CompanyRemovalRequestedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitMetadataUpdatedType = typeof UnitMetadataUpdatedType[keyof typeof UnitMetadataUpdatedType];


export const UnitMetadataUpdatedType = {
  UnitMetadataUpdated: 'UnitMetadataUpdated',
} as const;

export type UnitMetadataUpdated = {
  id: number;
  type: UnitMetadataUpdatedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitTransferredOutType = typeof UnitTransferredOutType[keyof typeof UnitTransferredOutType];


export const UnitTransferredOutType = {
  UnitTransferredOut: 'UnitTransferredOut',
} as const;

export type UnitTransferredOut = {
  id: number;
  type: UnitTransferredOutType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitTransferredInType = typeof UnitTransferredInType[keyof typeof UnitTransferredInType];


export const UnitTransferredInType = {
  UnitTransferredIn: 'UnitTransferredIn',
} as const;

export type UnitTransferredIn = {
  id: number;
  type: UnitTransferredInType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitSplittedType = typeof UnitSplittedType[keyof typeof UnitSplittedType];


export const UnitSplittedType = {
  UnitSplitted: 'UnitSplitted',
} as const;

export type UnitSplitted = {
  id: number;
  type: UnitSplittedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitClaimedType = typeof UnitClaimedType[keyof typeof UnitClaimedType];


export const UnitClaimedType = {
  UnitClaimed: 'UnitClaimed',
} as const;

export type UnitClaimed = {
  id: number;
  type: UnitClaimedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitIssuedType = typeof UnitIssuedType[keyof typeof UnitIssuedType];


export const UnitIssuedType = {
  UnitIssued: 'UnitIssued',
} as const;

export type UnitIssued = {
  id: number;
  type: UnitIssuedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitNewTreeIssuedType = typeof UnitNewTreeIssuedType[keyof typeof UnitNewTreeIssuedType];


export const UnitNewTreeIssuedType = {
  UnitNewTreeIssued: 'UnitNewTreeIssued',
} as const;

export type UnitNewTreeIssued = {
  id: number;
  type: UnitNewTreeIssuedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitBlockedType = typeof UnitBlockedType[keyof typeof UnitBlockedType];


export const UnitBlockedType = {
  UnitBlocked: 'UnitBlocked',
} as const;

export type UnitBlocked = {
  id: number;
  type: UnitBlockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitRemovedType = typeof UnitRemovedType[keyof typeof UnitRemovedType];


export const UnitRemovedType = {
  UnitRemoved: 'UnitRemoved',
} as const;

export type UnitRemoved = {
  id: number;
  type: UnitRemovedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type UnitUnblockedType = typeof UnitUnblockedType[keyof typeof UnitUnblockedType];


export const UnitUnblockedType = {
  UnitUnblocked: 'UnitUnblocked',
} as const;

export type UnitUnblocked = {
  id: number;
  type: UnitUnblockedType;
  eventName: string;
  date: string;
  affectedAccountId?: string;
  affectedAccountName?: string;
  affectedAccountCompanyId?: string;
  affectedAccountCompanyName?: string;
  affectedCompanyId?: string;
  affectedCompanyName?: string;
  affectedUserId?: string;
  affectedUserName?: string;
  affectedProcessId?: string;
  affectedUnitId?: string;
  triggerUserId?: string;
  triggerUserName?: string;
  triggerRegistryAdmin?: boolean;
};

export type GetSauronEventsResponse = {
  events: (AccountRepRemovalSucceeded | AccountUpdated | AccountClosed | AccountBlocked | AccountUnblocked | AccountMembershipAdded | MembershipRoleChanged | AccountCreated | TrustedRecipientAdded | TrustedRecipientRemoved | AccountUpdateRejected | AccountUpdateApproved | AccountCreationApproved | AccountCreationRejected | UserRemovalSucceeded | UserBlocked | UserUnblocked | UserInfoUpdated | ApprovalApproved | ApprovalClosed | ApprovalRejected | CompanyUserRemovalSucceeded | CompanyUpdated | CompanyClosed | CompanyBlocked | CompanyUnblocked | CompanyUpdateDocsRequested | CompanyAwaitingReview | CompanyActive | CompanyRemoved | CompanyMembershipAdded | CompanyMembershipChanged | ArOnboardingCreated | ArOnboardingRevoked | ArOnboardingRejected | CrOnboardingCreated | CrOnboardingRevoked | CrOnboardingRejected | RaInvited | VerificationInitialized | VerificationClosed | VerificationResultHandled | TicketCreated | UnitProcessSignatureSigned | UnitProcessSignatureRejected | UnitProcessAcceptanceAccepted | UnitProcessAcceptanceRejected | UnitProcessApprovalApproved | UnitProcessApprovalRejected | UnitProcessCancelled | UnitProcessInitiated | CompanyRemovalRequested | UnitMetadataUpdated | UnitTransferredOut | UnitTransferredIn | UnitSplitted | UnitClaimed | UnitIssued | UnitNewTreeIssued | UnitBlocked | UnitRemoved | UnitUnblocked)[];
  count: number;
  pages: number;
};

export type PermissionsResponse = {
  canManageCensorship: boolean;
};

export type SimpleUserResponse = {
  isAuthenticated: boolean;
  /** @nullable */
  userId: string | null;
  permissions: PermissionsResponse;
};

export type PublicUnitResponseItem = {
  id: string;
  rootId: string;
  volume: number;
  ownerId: MaybeCensoredOwnerId;
  isLast: MaybeCensoredIsLast;
  computed: MaybeCensoredComputed;
  metadata: MaybeCensoredMetadata;
  type: MaybeCensoredType;
  status: MaybeCensoredStatus;
};

export type PublicUnitResponse = {
  count: number;
  items: PublicUnitResponseItem[];
};

export type LandingPageDataResponse = {
  supplyCountriesOfOrigin: number;
  uniqueSuppliers: number;
  fuelProviders: number;
  safCaVolume: number;
  co2Abated: number;
  aviationCustomers: number;
  airTransportProviders: number;
  logisticServiceProviders: number;
};

export type PublicExportRequestSortBy = typeof PublicExportRequestSortBy[keyof typeof PublicExportRequestSortBy];


export const PublicExportRequestSortBy = {
  unitType: 'unitType',
  id: 'id',
  issuanceDate: 'issuanceDate',
  volume: 'volume',
  free_volume: 'free_volume',
  status: 'status',
  expirationDate: 'expirationDate',
  co2Abated: 'co2Abated',
  freeCo2Abated: 'freeCo2Abated',
  airTransportProviderBeneficiary: 'airTransportProviderBeneficiary',
  endUserBeneficiary: 'endUserBeneficiary',
  logisticsProviderBeneficiary: 'logisticsProviderBeneficiary',
  productionYear: 'productionYear',
  typeCode: 'typeCode',
  fuelProducingCompanyName: 'fuelProducingCompanyName',
  carbonIntensityScore: 'carbonIntensityScore',
  feedstockCountries: 'feedstockCountries',
  certificationScheme: 'certificationScheme',
  productionFeedstock: 'productionFeedstock',
  created_at: 'created_at',
  retiredAt: 'retiredAt',
  SAFcAClaimBeneficiaryCompanyName: 'SAFcAClaimBeneficiaryCompanyName',
  SAFcEClaimBeneficiaryCompanyName: 'SAFcEClaimBeneficiaryCompanyName',
  logisticsProviderBeneficiaryCompanyName: 'logisticsProviderBeneficiaryCompanyName',
} as const;

export type PublicExportRequestOrder = typeof PublicExportRequestOrder[keyof typeof PublicExportRequestOrder];


export const PublicExportRequestOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PublicExportRequest = {
  limit?: number;
  offset?: number;
  type: UnitViewSearchType;
  sortBy?: PublicExportRequestSortBy;
  order?: PublicExportRequestOrder;
  search?: string;
  /** @deprecated */
  history?: string;
  unitIds?: string[];
  fields?: ExportRequestField[];
  fileName?: string;
};

export type VerifiedComputeTypeDTO = {
  type: string;
  name: string;
};

export type ExplorerConfigResponse = {
  verifiedComputeTypes: VerifiedComputeTypeDTO[];
};

export type VerifiedComputeSimpleDTOStatus = typeof VerifiedComputeSimpleDTOStatus[keyof typeof VerifiedComputeSimpleDTOStatus];


export const VerifiedComputeSimpleDTOStatus = {
  created: 'created',
  pending: 'pending',
  success: 'success',
  pending_retry: 'pending_retry',
  retried: 'retried',
} as const;

export type VerifiedComputeSimpleDTO = {
  votingId: string;
  type: string;
  assetId: string;
  status: VerifiedComputeSimpleDTOStatus;
  createdAt: string;
  updatedAt: string;
  /** @nullable */
  output: string | null;
};

export type ExplorerListResponse = {
  count: number;
  data: VerifiedComputeSimpleDTO[];
};

export type ExplorerAssetResponse = {
  source: string;
  volume: number;
  typeCode: string;
  verifiedComputes: VerifiedComputeSimpleDTO[];
  assetId: string;
  assetRegistryUrl: string;
};

export type UnitWorkerMessageStructuredInputFormat = typeof UnitWorkerMessageStructuredInputFormat[keyof typeof UnitWorkerMessageStructuredInputFormat];


export const UnitWorkerMessageStructuredInputFormat = {
  date: 'date',
} as const;

export type VerifiedComputeInputDTO = {
  /** Input property name */
  name: string;
  value: string | number | boolean;
  format?: UnitWorkerMessageStructuredInputFormat;
};

/**
 * If it is the same as verified compute output
 */
export type VerifiedComputeVoteStatus = typeof VerifiedComputeVoteStatus[keyof typeof VerifiedComputeVoteStatus];


export const VerifiedComputeVoteStatus = {
  correct: 'correct',
  incorrect: 'incorrect',
  pending: 'pending',
} as const;

export type VerifiedComputeVoteDTO = {
  /** If it is the same as verified compute output */
  status: VerifiedComputeVoteStatus;
  value: string;
};

export type VerifiedComputeExternalExplorerDTO = {
  polkadotUrl: string;
  subscanUrl: string;
};

export type VerifiedComputeDTOStatus = typeof VerifiedComputeDTOStatus[keyof typeof VerifiedComputeDTOStatus];


export const VerifiedComputeDTOStatus = {
  created: 'created',
  pending: 'pending',
  success: 'success',
  pending_retry: 'pending_retry',
  retried: 'retried',
} as const;

export type VerifiedComputeDTO = {
  votingId: string;
  type: string;
  assetId: string;
  status: VerifiedComputeDTOStatus;
  createdAt: string;
  updatedAt: string;
  /** @nullable */
  output: string | null;
  input: VerifiedComputeInputDTO[];
  votes: VerifiedComputeVoteDTO[];
  /** @nullable */
  externalExplorerUrls: VerifiedComputeExternalExplorerDTO | null;
  description: string;
};

export type CensorshipTargetDTOTarget = typeof CensorshipTargetDTOTarget[keyof typeof CensorshipTargetDTOTarget];


export const CensorshipTargetDTOTarget = {
  assuranceLevel: 'assuranceLevel',
  adjustedLCAChoice: 'adjustedLCAChoice',
  documentationType: 'documentationType',
  fileTool: 'fileTool',
  batchcompanyName: 'batch.companyName',
  batchfuelProviderCompanyName: 'batch.fuelProviderCompanyName',
  batchleaveDate: 'batch.leaveDate',
  batchbatchNumber: 'batch.batchNumber',
  batchproductionYear: 'batch.productionYear',
  batchupliftCountry: 'batch.upliftCountry',
  batchupliftAirport: 'batch.upliftAirport',
  batchregulatorySchemesDeclaration: 'batch.regulatorySchemesDeclaration',
  batchadditionalityApproachtype: 'batch.additionalityApproach.type',
  batchadditionalityApproachallowScope3Claims: 'batch.additionalityApproach.allowScope3Claims',
  batchadditionalityApproachapproachName: 'batch.additionalityApproach.approachName',
  blendingisBlended: 'blending.isBlended',
  blendingblendingDate: 'blending.blendingDate',
  blendingblendingLocation: 'blending.blendingLocation',
  suppliersiteName: 'supplier.siteName',
  suppliersiteAddress: 'supplier.siteAddress',
  certificationscheme: 'certification.scheme',
  certificationhasIRS7210ForIsccPlus: 'certification.hasIRS7210ForIsccPlus',
  certificationhasSeparateRFNBORCF: 'certification.hasSeparateRFNBORCF',
  certificationtype: 'certification.type',
  certificationcertificateNumber: 'certification.certificateNumber',
  certificationcertificationBody: 'certification.certificationBody',
  certificationexpiryDate: 'certification.expiryDate',
  certificationcertificationBodyEmail: 'certification.certificationBodyEmail',
  certificationtraderCertificationNumber: 'certification.traderCertificationNumber',
  certificationadditionalScheme: 'certification.additionalScheme',
  certificationadditionalHasIRS7210ForIsccPlus: 'certification.additionalHasIRS7210ForIsccPlus',
  certificationadditionalHasSeparateRFNBORCF: 'certification.additionalHasSeparateRFNBORCF',
  certificationadditionalSchemeName: 'certification.additionalSchemeName',
  certificationadditionalCertificateNumber: 'certification.additionalCertificateNumber',
  certificationadditionalExpiryDate: 'certification.additionalExpiryDate',
  certificationadditionalCertificationBody: 'certification.additionalCertificationBody',
  certificationadditionalCertificationBodyEmail: 'certification.additionalCertificationBodyEmail',
  certificationisLowILUCRiskConfirmed: 'certification.isLowILUCRiskConfirmed',
  certificationlowRiskFollowUnusedLandApproach: 'certification.lowRiskFollowUnusedLandApproach',
  certificationlowRiskAuditCertificateNumber: 'certification.lowRiskAuditCertificateNumber',
  certificationlowRiskAuditExpiryDate: 'certification.lowRiskAuditExpiryDate',
  certificationlowRiskAuditCertificationBody: 'certification.lowRiskAuditCertificationBody',
  certificationlowRiskAuditCertificationBodyEmail: 'certification.lowRiskAuditCertificationBodyEmail',
  certificationisLowDisplacementRiskConfirmed: 'certification.isLowDisplacementRiskConfirmed',
  certificationlowDisplacementRiskAuditCertificateNumber: 'certification.lowDisplacementRiskAuditCertificateNumber',
  certificationlowDisplacementRiskAuditExpiryDate: 'certification.lowDisplacementRiskAuditExpiryDate',
  certificationlowDisplacementRiskAuditCertificationBody: 'certification.lowDisplacementRiskAuditCertificationBody',
  certificationlowDisplacementRiskAuditCertificationBodyEmail: 'certification.lowDisplacementRiskAuditCertificationBodyEmail',
  productfeedStockname: 'product.feedStock.name',
  productfeedStockotherFeedStock: 'product.feedStock.otherFeedStock',
  productfeedStockwasCertifiedAsProductionResidue: 'product.feedStock.wasCertifiedAsProductionResidue',
  productfeedStockisSolidWaste: 'product.feedStock.isSolidWaste',
  productfeedStockisEnergyCrop: 'product.feedStock.isEnergyCrop',
  productfeedStockisLanduseBasedCropBased: 'product.feedStock.isLanduseBasedCropBased',
  productfeedStockisCorsiaDefaultIlucLcaLteZero: 'product.feedStock.isCorsiaDefaultIlucLcaLteZero',
  productfeedStockisInEuRed2Annex9PartA: 'product.feedStock.isInEuRed2Annex9PartA',
  productvolumeOfNeatFuel: 'product.volumeOfNeatFuel',
  productvolumeOfNeatFuelUnit: 'product.volumeOfNeatFuelUnit',
  productquantityMT: 'product.quantityMT',
  productisFeedStockMsw: 'product.isFeedStockMsw',
  productcountries: 'product.countries',
  productconversionProcess: 'product.conversionProcess',
  productlowerHeatingValue: 'product.lowerHeatingValue',
  productjetFuelBaselineCarbonIntensity: 'product.jetFuelBaselineCarbonIntensity',
  greenhouseGastotalLCAValueCorsiaDefault: 'greenhouseGas.totalLCAValueCorsiaDefault',
  greenhouseGastotalLCAValueCorsiaActual: 'greenhouseGas.totalLCAValueCorsiaActual',
  greenhouseGastotalLCAValueEuDefault: 'greenhouseGas.totalLCAValueEuDefault',
  greenhouseGastotalLCAValueEuActual: 'greenhouseGas.totalLCAValueEuActual',
  greenhouseGascoreLCAValue: 'greenhouseGas.coreLCAValue',
  greenhouseGasinducedLandUseChange: 'greenhouseGas.inducedLandUseChange',
  greenhouseGasrecyclingEmissionsCredits: 'greenhouseGas.recyclingEmissionsCredits',
  greenhouseGaslandfillEmissionsCredits: 'greenhouseGas.landfillEmissionsCredits',
  greenhouseGasghgDisplacementEmissions: 'greenhouseGas.ghgDisplacementEmissions',
  greenhouseGasdisplacementEmissions: 'greenhouseGas.displacementEmissions',
  greenhouseGasproduction: 'greenhouseGas.production',
  greenhouseGasconditioning: 'greenhouseGas.conditioning',
  greenhouseGasprocessing: 'greenhouseGas.processing',
  greenhouseGastransportation: 'greenhouseGas.transportation',
  greenhouseGasfuelTransportation: 'greenhouseGas.fuelTransportation',
  greenhouseGasconversionProcesses: 'greenhouseGas.conversionProcesses',
  greenhouseGascombustion: 'greenhouseGas.combustion',
  greenhouseGasemissionsSavingsDueToSoilCarbonSequestration: 'greenhouseGas.emissionsSavingsDueToSoilCarbonSequestration',
  greenhouseGasemissionsSavingsFromCSS: 'greenhouseGas.emissionsSavingsFromCSS',
  greenhouseGassavingsFromSoil: 'greenhouseGas.savingsFromSoil',
  greenhouseGasextractionEmissions: 'greenhouseGas.extractionEmissions',
  greenhouseGasannualisedEmissions: 'greenhouseGas.annualisedEmissions',
  greenhouseGasprocessingEmissions: 'greenhouseGas.processingEmissions',
  greenhouseGastransportEmissions: 'greenhouseGas.transportEmissions',
  greenhouseGasinUseFuelEmissions: 'greenhouseGas.inUseFuelEmissions',
  greenhouseGassavingsFromCarbonAndStorage: 'greenhouseGas.savingsFromCarbonAndStorage',
  greenhouseGassavingsFromCarbonAndReplacement: 'greenhouseGas.savingsFromCarbonAndReplacement',
  greenhouseGassavingsFromExcess: 'greenhouseGas.savingsFromExcess',
  greenhouseGastotalLCAValueincludeEmissionsFromDeliveryToAirport: 'greenhouseGas.totalLCAValueincludeEmissionsFromDeliveryToAirport',
  greenhouseGasuseDefaultValueForDeliveryToAirport: 'greenhouseGas.useDefaultValueForDeliveryToAirport',
  greenhouseGasactualGHGIntensityAirportDelivery: 'greenhouseGas.actualGHGIntensityAirportDelivery',
  retirementSAFcEBeneficiary: 'retirement.SAFcEBeneficiary',
  retirementSAFcABeneficiary: 'retirement.SAFcABeneficiary',
  retirementlogisticsProvidierBeneficiary: 'retirement.logisticsProvidierBeneficiary',
  retirementcomplianceRegime: 'retirement.complianceRegime',
  retirementretirementYear: 'retirement.retirementYear',
  retirementretirementCountry: 'retirement.retirementCountry',
  retirementclaimPurpose: 'retirement.claimPurpose',
  computedhistoryOwnerTypes: 'computed.historyOwnerTypes',
  computedhistoryCompanyCount: 'computed.historyCompanyCount',
  computedrootOwner: 'computed.rootOwner',
  computedownerName: 'computed.ownerName',
  computedownerCompanyName: 'computed.ownerCompanyName',
  computedissuanceDate: 'computed.issuanceDate',
} as const;

export type CensorshipTargetDTO = {
  target: CensorshipTargetDTOTarget;
  /** List of paths that this censorship target covers - this is not accurate list, just one that gives a bit more context on what this target covers */
  paths: string[];
};

export type NewCensorshipRequestTarget = typeof NewCensorshipRequestTarget[keyof typeof NewCensorshipRequestTarget];


export const NewCensorshipRequestTarget = {
  assuranceLevel: 'assuranceLevel',
  adjustedLCAChoice: 'adjustedLCAChoice',
  documentationType: 'documentationType',
  fileTool: 'fileTool',
  batchcompanyName: 'batch.companyName',
  batchfuelProviderCompanyName: 'batch.fuelProviderCompanyName',
  batchleaveDate: 'batch.leaveDate',
  batchbatchNumber: 'batch.batchNumber',
  batchproductionYear: 'batch.productionYear',
  batchupliftCountry: 'batch.upliftCountry',
  batchupliftAirport: 'batch.upliftAirport',
  batchregulatorySchemesDeclaration: 'batch.regulatorySchemesDeclaration',
  batchadditionalityApproachtype: 'batch.additionalityApproach.type',
  batchadditionalityApproachallowScope3Claims: 'batch.additionalityApproach.allowScope3Claims',
  batchadditionalityApproachapproachName: 'batch.additionalityApproach.approachName',
  blendingisBlended: 'blending.isBlended',
  blendingblendingDate: 'blending.blendingDate',
  blendingblendingLocation: 'blending.blendingLocation',
  suppliersiteName: 'supplier.siteName',
  suppliersiteAddress: 'supplier.siteAddress',
  certificationscheme: 'certification.scheme',
  certificationhasIRS7210ForIsccPlus: 'certification.hasIRS7210ForIsccPlus',
  certificationhasSeparateRFNBORCF: 'certification.hasSeparateRFNBORCF',
  certificationtype: 'certification.type',
  certificationcertificateNumber: 'certification.certificateNumber',
  certificationcertificationBody: 'certification.certificationBody',
  certificationexpiryDate: 'certification.expiryDate',
  certificationcertificationBodyEmail: 'certification.certificationBodyEmail',
  certificationtraderCertificationNumber: 'certification.traderCertificationNumber',
  certificationadditionalScheme: 'certification.additionalScheme',
  certificationadditionalHasIRS7210ForIsccPlus: 'certification.additionalHasIRS7210ForIsccPlus',
  certificationadditionalHasSeparateRFNBORCF: 'certification.additionalHasSeparateRFNBORCF',
  certificationadditionalSchemeName: 'certification.additionalSchemeName',
  certificationadditionalCertificateNumber: 'certification.additionalCertificateNumber',
  certificationadditionalExpiryDate: 'certification.additionalExpiryDate',
  certificationadditionalCertificationBody: 'certification.additionalCertificationBody',
  certificationadditionalCertificationBodyEmail: 'certification.additionalCertificationBodyEmail',
  certificationisLowILUCRiskConfirmed: 'certification.isLowILUCRiskConfirmed',
  certificationlowRiskFollowUnusedLandApproach: 'certification.lowRiskFollowUnusedLandApproach',
  certificationlowRiskAuditCertificateNumber: 'certification.lowRiskAuditCertificateNumber',
  certificationlowRiskAuditExpiryDate: 'certification.lowRiskAuditExpiryDate',
  certificationlowRiskAuditCertificationBody: 'certification.lowRiskAuditCertificationBody',
  certificationlowRiskAuditCertificationBodyEmail: 'certification.lowRiskAuditCertificationBodyEmail',
  certificationisLowDisplacementRiskConfirmed: 'certification.isLowDisplacementRiskConfirmed',
  certificationlowDisplacementRiskAuditCertificateNumber: 'certification.lowDisplacementRiskAuditCertificateNumber',
  certificationlowDisplacementRiskAuditExpiryDate: 'certification.lowDisplacementRiskAuditExpiryDate',
  certificationlowDisplacementRiskAuditCertificationBody: 'certification.lowDisplacementRiskAuditCertificationBody',
  certificationlowDisplacementRiskAuditCertificationBodyEmail: 'certification.lowDisplacementRiskAuditCertificationBodyEmail',
  productfeedStockname: 'product.feedStock.name',
  productfeedStockotherFeedStock: 'product.feedStock.otherFeedStock',
  productfeedStockwasCertifiedAsProductionResidue: 'product.feedStock.wasCertifiedAsProductionResidue',
  productfeedStockisSolidWaste: 'product.feedStock.isSolidWaste',
  productfeedStockisEnergyCrop: 'product.feedStock.isEnergyCrop',
  productfeedStockisLanduseBasedCropBased: 'product.feedStock.isLanduseBasedCropBased',
  productfeedStockisCorsiaDefaultIlucLcaLteZero: 'product.feedStock.isCorsiaDefaultIlucLcaLteZero',
  productfeedStockisInEuRed2Annex9PartA: 'product.feedStock.isInEuRed2Annex9PartA',
  productvolumeOfNeatFuel: 'product.volumeOfNeatFuel',
  productvolumeOfNeatFuelUnit: 'product.volumeOfNeatFuelUnit',
  productquantityMT: 'product.quantityMT',
  productisFeedStockMsw: 'product.isFeedStockMsw',
  productcountries: 'product.countries',
  productconversionProcess: 'product.conversionProcess',
  productlowerHeatingValue: 'product.lowerHeatingValue',
  productjetFuelBaselineCarbonIntensity: 'product.jetFuelBaselineCarbonIntensity',
  greenhouseGastotalLCAValueCorsiaDefault: 'greenhouseGas.totalLCAValueCorsiaDefault',
  greenhouseGastotalLCAValueCorsiaActual: 'greenhouseGas.totalLCAValueCorsiaActual',
  greenhouseGastotalLCAValueEuDefault: 'greenhouseGas.totalLCAValueEuDefault',
  greenhouseGastotalLCAValueEuActual: 'greenhouseGas.totalLCAValueEuActual',
  greenhouseGascoreLCAValue: 'greenhouseGas.coreLCAValue',
  greenhouseGasinducedLandUseChange: 'greenhouseGas.inducedLandUseChange',
  greenhouseGasrecyclingEmissionsCredits: 'greenhouseGas.recyclingEmissionsCredits',
  greenhouseGaslandfillEmissionsCredits: 'greenhouseGas.landfillEmissionsCredits',
  greenhouseGasghgDisplacementEmissions: 'greenhouseGas.ghgDisplacementEmissions',
  greenhouseGasdisplacementEmissions: 'greenhouseGas.displacementEmissions',
  greenhouseGasproduction: 'greenhouseGas.production',
  greenhouseGasconditioning: 'greenhouseGas.conditioning',
  greenhouseGasprocessing: 'greenhouseGas.processing',
  greenhouseGastransportation: 'greenhouseGas.transportation',
  greenhouseGasfuelTransportation: 'greenhouseGas.fuelTransportation',
  greenhouseGasconversionProcesses: 'greenhouseGas.conversionProcesses',
  greenhouseGascombustion: 'greenhouseGas.combustion',
  greenhouseGasemissionsSavingsDueToSoilCarbonSequestration: 'greenhouseGas.emissionsSavingsDueToSoilCarbonSequestration',
  greenhouseGasemissionsSavingsFromCSS: 'greenhouseGas.emissionsSavingsFromCSS',
  greenhouseGassavingsFromSoil: 'greenhouseGas.savingsFromSoil',
  greenhouseGasextractionEmissions: 'greenhouseGas.extractionEmissions',
  greenhouseGasannualisedEmissions: 'greenhouseGas.annualisedEmissions',
  greenhouseGasprocessingEmissions: 'greenhouseGas.processingEmissions',
  greenhouseGastransportEmissions: 'greenhouseGas.transportEmissions',
  greenhouseGasinUseFuelEmissions: 'greenhouseGas.inUseFuelEmissions',
  greenhouseGassavingsFromCarbonAndStorage: 'greenhouseGas.savingsFromCarbonAndStorage',
  greenhouseGassavingsFromCarbonAndReplacement: 'greenhouseGas.savingsFromCarbonAndReplacement',
  greenhouseGassavingsFromExcess: 'greenhouseGas.savingsFromExcess',
  greenhouseGastotalLCAValueincludeEmissionsFromDeliveryToAirport: 'greenhouseGas.totalLCAValueincludeEmissionsFromDeliveryToAirport',
  greenhouseGasuseDefaultValueForDeliveryToAirport: 'greenhouseGas.useDefaultValueForDeliveryToAirport',
  greenhouseGasactualGHGIntensityAirportDelivery: 'greenhouseGas.actualGHGIntensityAirportDelivery',
  retirementSAFcEBeneficiary: 'retirement.SAFcEBeneficiary',
  retirementSAFcABeneficiary: 'retirement.SAFcABeneficiary',
  retirementlogisticsProvidierBeneficiary: 'retirement.logisticsProvidierBeneficiary',
  retirementcomplianceRegime: 'retirement.complianceRegime',
  retirementretirementYear: 'retirement.retirementYear',
  retirementretirementCountry: 'retirement.retirementCountry',
  retirementclaimPurpose: 'retirement.claimPurpose',
  computedhistoryOwnerTypes: 'computed.historyOwnerTypes',
  computedhistoryCompanyCount: 'computed.historyCompanyCount',
  computedrootOwner: 'computed.rootOwner',
  computedownerName: 'computed.ownerName',
  computedownerCompanyName: 'computed.ownerCompanyName',
  computedissuanceDate: 'computed.issuanceDate',
} as const;

export type NewCensorshipRequestType = typeof NewCensorshipRequestType[keyof typeof NewCensorshipRequestType];


export const NewCensorshipRequestType = {
  single: 'single',
  graph: 'graph',
} as const;

export type NewCensorshipRequest = {
  unitId: string;
  target: NewCensorshipRequestTarget;
  type: NewCensorshipRequestType;
};

export type CensorshipRuleDTOType = typeof CensorshipRuleDTOType[keyof typeof CensorshipRuleDTOType];


export const CensorshipRuleDTOType = {
  single: 'single',
  graph: 'graph',
} as const;

export type CensorshipRuleDTO = {
  type: CensorshipRuleDTOType;
  target: CensorshipTargetDTO;
  id: string;
};

export type GetRulesForUnitResponse = {
  rules: CensorshipRuleDTO[];
};

export type AccessTokenResponsePermissionsItem = typeof AccessTokenResponsePermissionsItem[keyof typeof AccessTokenResponsePermissionsItem];


export const AccessTokenResponsePermissionsItem = {
  read: 'read',
  write: 'write',
} as const;

export type AccessTokenResponse = {
  id: string;
  name: string;
  createdAt: string;
  permissions: AccessTokenResponsePermissionsItem[];
};

export type CreateTokenRequest = {
  name: string;
  permissions: string[];
};

export type AccessTokenCreatedResponsePermissionsItem = typeof AccessTokenCreatedResponsePermissionsItem[keyof typeof AccessTokenCreatedResponsePermissionsItem];


export const AccessTokenCreatedResponsePermissionsItem = {
  read: 'read',
  write: 'write',
} as const;

export type AccessTokenCreatedResponse = {
  id: string;
  name: string;
  createdAt: string;
  permissions: AccessTokenCreatedResponsePermissionsItem[];
  token: string;
};

export type ErrorResponseDetails = { [key: string]: unknown };

export type ErrorResponse = {
  message: string;
  statusCode: number;
  errorId: string;
  details: ErrorResponseDetails;
};

export type AuthError = typeof AuthError[keyof typeof AuthError];


export const AuthError = {
  unknown: 'unknown',
  notRegistered: 'notRegistered',
} as const;

export type AuthErrorDTO = {
  error: AuthError;
};

export type AuthControllerLoginParams = {
continuePath?: string;
};

export type AuthControllerExchangeFromQueryParams = {
token: string;
continuePath?: string;
};

export type AuthControllerLogoutByQueryParams = {
continuePath?: string;
};

export type FileControllerGetFilesDetailsParams = {
fileIds: string[];
};

export type CompanyControllerGetCompanyDataParams = {
companyId: string;
};

export type CompanyControllerUpdateCompanyParams = {
companyId: string;
};

export type CompanyControllerRemoveCompanyParams = {
companyId: string;
};

export type CompanyControllerCloseMembershipParams = {
companyId: string;
};

export type CompanyControllerUpdateNamePrivacyParams = {
companyId: string;
};

export type CompanyControllerBlockCompanyParams = {
companyId: string;
};

export type CompanyControllerUnblockCompanyParams = {
companyId: string;
};

export type CompanyControllerUpdateCompanyDocumentsParams = {
companyId: string;
};

export type CompanyControllerAddCompanyRepParams = {
companyId: string;
};

export type CompanyControllerRevokeCompanyRepInviteParams = {
companyId: string;
};

export type CompanyControllerPromoteToCompanyRepsParams = {
companyId: string;
};

export type CompanyControllerCloseCompanyParams = {
companyId: string;
};

export type AccountControllerListAccountsToTransferParams = {
accountId: string;
};

export type AccountControllerUpdateAccountParams = {
companyId?: string;
};

export type AccountControllerCreateParams = {
companyId: string;
};

export type AccountControllerGetMyAccountsParams = {
companyId?: string;
type?: AccountControllerGetMyAccountsType;
/**
 * Skip closed accounts in listing
 */
skipClosed?: boolean;
/**
 * Skip rejected accounts in listing
 */
skipRejected?: boolean;
};

export type AccountControllerGetMyAccountsType = typeof AccountControllerGetMyAccountsType[keyof typeof AccountControllerGetMyAccountsType];


export const AccountControllerGetMyAccountsType = {
  airTransportProviderHoldingAccount: 'airTransportProviderHoldingAccount',
  fuelProviderHoldingAccount: 'fuelProviderHoldingAccount',
  generalHoldingAccount: 'generalHoldingAccount',
  logisticsProviderHoldingAccount: 'logisticsProviderHoldingAccount',
} as const;

export type AccountControllerGetUserAccountsParams = {
companyId: string;
};

export type AccountControllerCloseAccountRepParams = {
companyId?: string;
};

export type UserControllerGetUserDataParams = {
companyId: string;
};

export type UserControllerGetCompanyUsersParams = {
role?: CompanyRole;
companyId: string;
};

export type UserControllerGetCompanyInvitedUsersParams = {
companyId: string;
};

export type UserControllerGetAccountInvitedUsersParams = {
companyId: string;
};

export type ActionsControllerGetPendingActionsCountParams = {
companyId?: string;
};

export type ActionsControllerGetPendingActionsParams = {
companyId?: string;
};

export type ApprovalControllerGetAllWithPayloadParams = {
types?: ApprovalType[];
states?: ApprovalState[];
};

export type UnitControllerGetUnitsParams = {
limit?: number;
offset?: number;
ownerId: string;
type?: UnitViewSearchType;
unitType?: UnitControllerGetUnitsUnitType;
unitIds?: string[];
sortBy?: UnitViewSortBy;
order?: UnitControllerGetUnitsOrder;
search?: string;
filters?: FilterDTO;
history?: boolean;
};

export type UnitControllerGetUnitsUnitType = typeof UnitControllerGetUnitsUnitType[keyof typeof UnitControllerGetUnitsUnitType];


export const UnitControllerGetUnitsUnitType = {
  SAFcA: 'SAFcA',
  SAFcE: 'SAFcE',
} as const;

export type UnitControllerGetUnitsOrder = typeof UnitControllerGetUnitsOrder[keyof typeof UnitControllerGetUnitsOrder];


export const UnitControllerGetUnitsOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type UnitControllerUpdateUnitByIdBody = { [key: string]: unknown };

export type UnitProcessControllerGetUnitProcessesParams = {
limit?: number;
offset?: number;
state: QueryUnitProcessState;
search?: string;
accountId: string;
};

export type UnitProcessControllerExportProcessesParams = {
accountId: string;
};

export type UnitProcessControllerIssueBody = { [key: string]: unknown };

export type UnitProcessControllerSplitBody = {
  blockId: string;
  /** @minimum 0.001 */
  volume: number;
  accountId: string;
};

export type UnitProcessControllerIssueNewTreeBody = { [key: string]: unknown };

export type UnitProcessControllerTransferBody = {
  blockId: string;
  /** @minimum 0.001 */
  volume: number;
  recipientId?: string;
  accountId: string;
};

export type UnitProcessControllerBatchTransferBodyItem = { [key: string]: unknown };

export type UnitProcessControllerClaimParams = {
accountId: string;
};

export type UnitProcessControllerClaimBody = ({
  blockId: string;
  /** @minimum 0.001 */
  volume: number;
  accountId: string;
  /**
     * @minimum 2024
     * @maximum 2028
     */
  retirementYear: number;
  retirementCountry: string;
  retirementOnRegistryYear?: number;
  claimPurpose?: 'domestic' | 'international';
  /** @minItems 1 */
  complianceRegime?: ({
  type: 'corsia' | 'eu-ets' | 'eu-ets-support' | 'uk-ets' | 'illinois-purchase-credits' | 'new-zealand-ets' | 'none' | 'other';
  /** @minLength 1 */
  name?: string;
})[];
  logisticsProviderBeneficiary?: string;
  previousOwnerId?: string;
  safcClaimBeneficiary?: {
  ownerId: string;
} | {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
};
  sercClaimBeneficiary?: {
  ownerId: string;
} | {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
};
}) & {
  shouldCensorSafcBeneficiary: boolean;
  shouldCensorSercBeneficiary: boolean;
  shouldCensorLogisticsProviderBeneficiary: boolean;
};

export type UnitProcessControllerTransferAcceptanceAcceptParams = {
accountId: string;
};

export type UnitProcessControllerClaimAcceptanceAcceptParams = {
accountId: string;
};

export type UnitProcessControllerAcceptanceRejectParams = {
accountId: string;
};

export type UnitProcessControllerSignaturesSignParams = {
accountId: string;
};

export type UnitProcessControllerSignaturesRejectParams = {
accountId: string;
};

export type UnitProcessControllerCancelParams = {
accountId: string;
};

export type LogsControllerGetLogsByPermissionsParams = {
take: number;
/**
 * Starts counting from 0
 */
page?: number;
};

export type LogsControllerGetLogsByAffectedParams = {
take: number;
/**
 * Starts counting from 0
 */
page?: number;
companyIds: string[];
accountIds: string[];
userIds: string[];
};

export type LogsControllerGetAllLogsParams = {
take: number;
/**
 * Starts counting from 0
 */
page?: number;
};

export type PublicControllerGetUnitsParams = {
limit?: number;
offset?: number;
type: UnitViewSearchType;
sortBy?: PublicControllerGetUnitsSortBy;
order?: PublicControllerGetUnitsOrder;
search?: string;
history?: string;
};

export type PublicControllerGetUnitsSortBy = typeof PublicControllerGetUnitsSortBy[keyof typeof PublicControllerGetUnitsSortBy];


export const PublicControllerGetUnitsSortBy = {
  unitType: 'unitType',
  id: 'id',
  issuanceDate: 'issuanceDate',
  volume: 'volume',
  free_volume: 'free_volume',
  status: 'status',
  expirationDate: 'expirationDate',
  co2Abated: 'co2Abated',
  freeCo2Abated: 'freeCo2Abated',
  airTransportProviderBeneficiary: 'airTransportProviderBeneficiary',
  endUserBeneficiary: 'endUserBeneficiary',
  logisticsProviderBeneficiary: 'logisticsProviderBeneficiary',
  productionYear: 'productionYear',
  typeCode: 'typeCode',
  fuelProducingCompanyName: 'fuelProducingCompanyName',
  carbonIntensityScore: 'carbonIntensityScore',
  feedstockCountries: 'feedstockCountries',
  certificationScheme: 'certificationScheme',
  productionFeedstock: 'productionFeedstock',
  created_at: 'created_at',
  retiredAt: 'retiredAt',
  SAFcAClaimBeneficiaryCompanyName: 'SAFcAClaimBeneficiaryCompanyName',
  SAFcEClaimBeneficiaryCompanyName: 'SAFcEClaimBeneficiaryCompanyName',
  logisticsProviderBeneficiaryCompanyName: 'logisticsProviderBeneficiaryCompanyName',
} as const;

export type PublicControllerGetUnitsOrder = typeof PublicControllerGetUnitsOrder[keyof typeof PublicControllerGetUnitsOrder];


export const PublicControllerGetUnitsOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ExplorerControllerListParams = {
limit?: number;
offset?: number;
votingId?: string;
assetId?: string;
type?: string;
search?: string;
};

export type DevControllerLoginParams = {
redirect: boolean;
token?: string;
};

export type DevControllerLoginByEmailParams = {
redirect: boolean;
token?: string;
};

export type DevControllerMockKycResultParams = {
processId: string;
result: string;
token?: string;
};

export type DevControllerMockLastKycResultParams = {
email: string;
result: string;
token?: string;
};

